var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as url from 'url';
export function isResponseEmpty(response) {
    var contentLength = response.headers.get('Content-Length');
    return contentLength != null && Number.parseInt(contentLength, 10) === 0;
}
export function isResponseJson(response) {
    var contentType = response.headers.get('Content-Type');
    return contentType != null && contentType.indexOf('json') >= 0;
}
export function parseJson(response) {
    return !isResponseEmpty(response) && isResponseJson(response) ? response.json() : Promise.resolve();
}
export function parseHeaders(response) {
    var headers = {};
    response.headers.forEach(function (value, key) {
        headers[key.toLowerCase()] = value;
    });
    return headers;
}
export function stripQuery(query) {
    if (query === void 0) { query = {}; }
    var initialValue = {};
    return Object.keys(query).reduce(function (previousValue, key) {
        var value = query[key];
        if (value != null)
            previousValue[key] = value;
        return previousValue;
    }, initialValue);
}
var $HttpClient = /** @class */ (function () {
    function $HttpClient(options) {
        this.options = options;
    }
    $HttpClient.prototype.request = function (options) {
        var finalUrl = url.format({
            hostname: 'api.flow.io',
            pathname: options.endpoint,
            protocol: 'https:',
            query: stripQuery(options.query),
        });
        var finalHeaders = __assign({ accept: 'application/json', 'content-type': 'application/json' }, options.headers);
        var request = {
            body: options.body,
            headers: finalHeaders,
            method: options.method,
            url: finalUrl,
        };
        return this.options.fetch(request.url, {
            body: JSON.stringify(request.body),
            headers: request.headers,
            method: request.method,
        }).then(function (response) {
            return parseJson(response).then(function (json) {
                return {
                    body: json,
                    headers: parseHeaders(response),
                    ok: response.ok,
                    request: request,
                    status: response.status,
                    statusText: response.statusText,
                };
            });
        });
    };
    return $HttpClient;
}());
export { $HttpClient };
var $Resource = /** @class */ (function () {
    function $Resource(options) {
        this.client = new $HttpClient(options);
    }
    return $Resource;
}());
export { $Resource };
var AccountsResource = /** @class */ (function (_super) {
    __extends(AccountsResource, _super);
    function AccountsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccountsResource.prototype.putInternalByCurrency = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/" + encodeURIComponent(params.organization) + "/accounts/" + encodeURIComponent(params.currency),
            headers: params.headers,
            method: 'PUT',
        });
    };
    AccountsResource.prototype.deleteInternalByCurrency = function (params) {
        return this.client.request({
            endpoint: "/internal/" + encodeURIComponent(params.organization) + "/accounts/" + encodeURIComponent(params.currency),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    /*Creates a date on which to explicitly generate a billing statement*/
    AccountsResource.prototype.postInternalAndExplicitAndDatesByCurrency = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/" + encodeURIComponent(params.organization) + "/accounts/" + encodeURIComponent(params.currency) + "/explicit/dates",
            headers: params.headers,
            method: 'POST',
        });
    };
    AccountsResource.prototype.deleteInternalAndExplicitAndDatesByCurrencyAndId = function (params) {
        return this.client.request({
            endpoint: "/internal/" + encodeURIComponent(params.organization) + "/accounts/" + encodeURIComponent(params.currency) + "/explicit/dates/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    /*Creates a manual transaction for this account*/
    AccountsResource.prototype.postInternalAndTransactionsAndManualByCurrency = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/" + encodeURIComponent(params.organization) + "/accounts/" + encodeURIComponent(params.currency) + "/transactions/manual",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Deletes a manual transaction for this account, if not associated with a billing statement.*/
    AccountsResource.prototype.deleteInternalAndTransactionsAndManualByCurrencyAndId = function (params) {
        return this.client.request({
            endpoint: "/internal/" + encodeURIComponent(params.organization) + "/accounts/" + encodeURIComponent(params.currency) + "/transactions/manual/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    AccountsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/accounts",
            headers: params.headers,
            method: 'GET',
            query: {
                currency: params.currency,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    AccountsResource.prototype.getByCurrency = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/accounts/" + encodeURIComponent(params.currency),
            headers: params.headers,
            method: 'GET',
        });
    };
    AccountsResource.prototype.getContactsByCurrency = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/accounts/" + encodeURIComponent(params.currency) + "/contacts",
            headers: params.headers,
            method: 'GET',
            query: {
                email: params.email,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    AccountsResource.prototype.postContactsByCurrency = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/accounts/" + encodeURIComponent(params.currency) + "/contacts",
            headers: params.headers,
            method: 'POST',
        });
    };
    AccountsResource.prototype.getContactsByCurrencyAndId = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/accounts/" + encodeURIComponent(params.currency) + "/contacts/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    AccountsResource.prototype.deleteContactsByCurrencyAndId = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/accounts/" + encodeURIComponent(params.currency) + "/contacts/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    AccountsResource.prototype.getExplicitAndDatesByCurrency = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/accounts/" + encodeURIComponent(params.currency) + "/explicit/dates",
            headers: params.headers,
            method: 'GET',
            query: {
                has_billing_statement: params.has_billing_statement,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    AccountsResource.prototype.getExplicitAndDatesByCurrencyAndId = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/accounts/" + encodeURIComponent(params.currency) + "/explicit/dates/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    AccountsResource.prototype.getStatisticsByCurrency = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/accounts/" + encodeURIComponent(params.currency) + "/statistics",
            headers: params.headers,
            method: 'GET',
        });
    };
    AccountsResource.prototype.getTransactionsByCurrency = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/accounts/" + encodeURIComponent(params.currency) + "/transactions",
            headers: params.headers,
            method: 'GET',
            query: {
                created_after: params.created_after,
                created_before: params.created_before,
                created_from: params.created_from,
                created_on_or_after: params.created_on_or_after,
                created_on_or_before: params.created_on_or_before,
                created_to: params.created_to,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                posted_after: params.posted_after,
                posted_before: params.posted_before,
                posted_from: params.posted_from,
                posted_on_or_after: params.posted_on_or_after,
                posted_on_or_before: params.posted_on_or_before,
                posted_to: params.posted_to,
                sort: params.sort,
                statement: params.statement,
                status: params.status,
                type: params.type,
            },
        });
    };
    return AccountsResource;
}($Resource));
export { AccountsResource };
var AddressConfigurationSettingsResource = /** @class */ (function (_super) {
    __extends(AddressConfigurationSettingsResource, _super);
    function AddressConfigurationSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AddressConfigurationSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/address/configuration/settings",
            headers: params.headers,
            method: 'GET',
        });
    };
    AddressConfigurationSettingsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/address/configuration/settings",
            headers: params.headers,
            method: 'PUT',
        });
    };
    return AddressConfigurationSettingsResource;
}($Resource));
export { AddressConfigurationSettingsResource };
var AlertFailureSummariesResource = /** @class */ (function (_super) {
    __extends(AlertFailureSummariesResource, _super);
    function AlertFailureSummariesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns the most recent 100 error summaries for a service's failed events*/
    AlertFailureSummariesResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/internal/stats/events/failures/summaries',
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Returns the most recent 100 error summaries for a service's failed events*/
    AlertFailureSummariesResource.prototype.getByDb = function (params) {
        return this.client.request({
            endpoint: "/internal/stats/events/failures/summaries/" + encodeURIComponent(params.db),
            headers: params.headers,
            method: 'GET',
            query: {
                queue: params.queue,
            },
        });
    };
    AlertFailureSummariesResource.prototype.deleteByDbAndQueueAndId = function (params) {
        return this.client.request({
            endpoint: "/internal/stats/events/failures/summaries/" + encodeURIComponent(params.db) + "/" + encodeURIComponent(params.queue) + "/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return AlertFailureSummariesResource;
}($Resource));
export { AlertFailureSummariesResource };
var AlertRequeueSummariesResource = /** @class */ (function (_super) {
    __extends(AlertRequeueSummariesResource, _super);
    function AlertRequeueSummariesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Requeue failed events for the service*/
    AlertRequeueSummariesResource.prototype.post = function (params) {
        return this.client.request({
            endpoint: "/internal/stats/events/failures/" + encodeURIComponent(params.db) + "/requeue",
            headers: params.headers,
            method: 'POST',
        });
    };
    return AlertRequeueSummariesResource;
}($Resource));
export { AlertRequeueSummariesResource };
var AuthorizedChargeStatusesResource = /** @class */ (function (_super) {
    __extends(AuthorizedChargeStatusesResource, _super);
    function AuthorizedChargeStatusesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns the current status of charges for this order*/
    AuthorizedChargeStatusesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/status/charges",
            headers: params.headers,
            method: 'GET',
        });
    };
    return AuthorizedChargeStatusesResource;
}($Resource));
export { AuthorizedChargeStatusesResource };
var BackfillsResource = /** @class */ (function (_super) {
    __extends(BackfillsResource, _super);
    function BackfillsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BackfillsResource.prototype.putCumulativeAndDaily = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/experiment-engine/backfill/cumulative/daily',
            headers: params.headers,
            method: 'PUT',
        });
    };
    BackfillsResource.prototype.putDaily = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/experiment-engine/backfill/daily',
            headers: params.headers,
            method: 'PUT',
        });
    };
    BackfillsResource.prototype.putTotalsAndDaily = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/experiment-engine/backfill/totals/daily',
            headers: params.headers,
            method: 'PUT',
        });
    };
    return BackfillsResource;
}($Resource));
export { BackfillsResource };
var BankPaymentsResource = /** @class */ (function (_super) {
    __extends(BankPaymentsResource, _super);
    function BankPaymentsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BankPaymentsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/bank/payments',
            headers: params.headers,
            method: 'GET',
            query: {
                account_id: params.account_id,
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                organization: params.organization,
                sort: params.sort,
            },
        });
    };
    BankPaymentsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/bank/payments/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    BankPaymentsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/internal/bank/payments/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    BankPaymentsResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/bank/payments/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return BankPaymentsResource;
}($Resource));
export { BankPaymentsResource };
var BillingStatementsResource = /** @class */ (function (_super) {
    __extends(BillingStatementsResource, _super);
    function BillingStatementsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BillingStatementsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/account/statements",
            headers: params.headers,
            method: 'GET',
            query: {
                account_id: params.account_id,
                currency: params.currency,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    BillingStatementsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/account/statements/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    BillingStatementsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/account/statements/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    /*Generates and sends an email about this statement*/
    BillingStatementsResource.prototype.postEmailById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/account/statements/" + encodeURIComponent(params.id) + "/email",
            headers: params.headers,
            method: 'POST',
        });
    };
    return BillingStatementsResource;
}($Resource));
export { BillingStatementsResource };
var BillingStatementPendingReviewsResource = /** @class */ (function (_super) {
    __extends(BillingStatementPendingReviewsResource, _super);
    function BillingStatementPendingReviewsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BillingStatementPendingReviewsResource.prototype.getPending = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/internal/account/statement/reviews/pending',
            headers: params.headers,
            method: 'GET',
            query: {
                account_id: params.account_id,
                environment: params.environment,
                organization: params.organization,
            },
        });
    };
    return BillingStatementPendingReviewsResource;
}($Resource));
export { BillingStatementPendingReviewsResource };
var BillingStatementReviewsResource = /** @class */ (function (_super) {
    __extends(BillingStatementReviewsResource, _super);
    function BillingStatementReviewsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BillingStatementReviewsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/account/statement/reviews',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                organization: params.organization,
                sort: params.sort,
            },
        });
    };
    BillingStatementReviewsResource.prototype.putBillingAndStatementsByBillingStatementId = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/account/statement/reviews/billing/statements/" + encodeURIComponent(params.billing_statement_id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    BillingStatementReviewsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/account/statement/reviews/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    BillingStatementReviewsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/internal/account/statement/reviews/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return BillingStatementReviewsResource;
}($Resource));
export { BillingStatementReviewsResource };
var BrickWebhookEventsResource = /** @class */ (function (_super) {
    __extends(BrickWebhookEventsResource, _super);
    function BrickWebhookEventsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BrickWebhookEventsResource.prototype.getByFtpFolderId = function (params) {
        return this.client.request({
            endpoint: "/ftp/webhook/events/brickftp/" + encodeURIComponent(params.ftp_folder_id),
            headers: params.headers,
            method: 'GET',
            query: {
                action: params.action,
                at: params.at,
                destination: params.destination,
                interface: params.interface,
                path: params.path,
                type: params.type,
                username: params.username,
            },
        });
    };
    return BrickWebhookEventsResource;
}($Resource));
export { BrickWebhookEventsResource };
var BrowserBundlesResource = /** @class */ (function (_super) {
    __extends(BrowserBundlesResource, _super);
    function BrowserBundlesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*GET accepts a browser_bundle_form serialized to query parameters to enable caching via the CDN.*/
    BrowserBundlesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/bundles/browser",
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
            },
        });
    };
    BrowserBundlesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/bundles/browser",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
            },
        });
    };
    return BrowserBundlesResource;
}($Resource));
export { BrowserBundlesResource };
var CarrierAccountsResource = /** @class */ (function (_super) {
    __extends(CarrierAccountsResource, _super);
    function CarrierAccountsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CarrierAccountsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/carrier/accounts",
            headers: params.headers,
            method: 'GET',
            query: {
                carrier_id: params.carrier_id,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    CarrierAccountsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/carrier/accounts",
            headers: params.headers,
            method: 'POST',
        });
    };
    CarrierAccountsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/carrier/accounts/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    CarrierAccountsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/carrier/accounts/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    CarrierAccountsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/carrier/accounts/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return CarrierAccountsResource;
}($Resource));
export { CarrierAccountsResource };
var CenterQueryBuildersResource = /** @class */ (function (_super) {
    __extends(CenterQueryBuildersResource, _super);
    function CenterQueryBuildersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CenterQueryBuildersResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/center/query/builders",
            headers: params.headers,
            method: 'POST',
        });
    };
    return CenterQueryBuildersResource;
}($Resource));
export { CenterQueryBuildersResource };
var ChargebacksResource = /** @class */ (function (_super) {
    __extends(ChargebacksResource, _super);
    function ChargebacksResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChargebacksResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/chargebacks",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                payment_status: params.payment_status,
                sort: params.sort,
            },
        });
    };
    /*Provides visibility into recent changes of each object, including deletion.*/
    ChargebacksResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/chargebacks/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                chargeback_key: params.chargeback_key,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Returns information about a specific chargeback.*/
    ChargebacksResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/chargebacks/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
        });
    };
    return ChargebacksResource;
}($Resource));
export { ChargebacksResource };
var CheckoutBundlesResource = /** @class */ (function (_super) {
    __extends(CheckoutBundlesResource, _super);
    function CheckoutBundlesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Converts a cart into an order and returns all associated content needed to render checkout in a single bundle.*/
    CheckoutBundlesResource.prototype.postCartById = function (params) {
        return this.client.request({
            endpoint: "/bundles/checkout/cart/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'POST',
            query: {
                feature_q: params.feature_q,
            },
        });
    };
    /*Returns all associated content needed to render checkout.*/
    CheckoutBundlesResource.prototype.getOrderByOrgAndNumber = function (params) {
        return this.client.request({
            endpoint: "/bundles/checkout/" + encodeURIComponent(params.org) + "/order/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'GET',
            query: {
                feature_q: params.feature_q,
            },
        });
    };
    /*This method will either lookup or create a new order if possible based on the provided order number. The intent is to handle a 401 when the session id does not match - and enable returning a new order tied to the session with the same data (absent PII).*/
    CheckoutBundlesResource.prototype.postOrdersByOrg = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/bundles/checkout/" + encodeURIComponent(params.org) + "/orders",
            headers: params.headers,
            method: 'POST',
        });
    };
    return CheckoutBundlesResource;
}($Resource));
export { CheckoutBundlesResource };
var CheckoutConfigurationsResource = /** @class */ (function (_super) {
    __extends(CheckoutConfigurationsResource, _super);
    function CheckoutConfigurationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search checkout configurations. Always paginated.*/
    CheckoutConfigurationsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/checkout/configurations",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Create a new checkout configuration*/
    CheckoutConfigurationsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/checkout/configurations",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Returns information about a specific checkout configuration.*/
    CheckoutConfigurationsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/checkout/configurations/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Update an existing checkout configuration*/
    CheckoutConfigurationsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/checkout/configurations/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Removes an existing checkout configuration*/
    CheckoutConfigurationsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/checkout/configurations/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return CheckoutConfigurationsResource;
}($Resource));
export { CheckoutConfigurationsResource };
var CheckoutContentSummariesResource = /** @class */ (function (_super) {
    __extends(CheckoutContentSummariesResource, _super);
    function CheckoutContentSummariesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckoutContentSummariesResource.prototype.getCheckout = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/content/checkout",
            headers: params.headers,
            method: 'GET',
            query: {
                locale: params.locale,
            },
        });
    };
    /*Endpoint used to access data for the 'load' content type - This allows us to rewrite URLs to serve from api proxy, avoiding any issues with CORS*/
    CheckoutContentSummariesResource.prototype.getUrlByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/content/" + encodeURIComponent(params.key) + "/url",
            headers: params.headers,
            method: 'GET',
            query: {
                url: params.url,
            },
        });
    };
    return CheckoutContentSummariesResource;
}($Resource));
export { CheckoutContentSummariesResource };
var CheckoutFinalizeOrderFormsResource = /** @class */ (function (_super) {
    __extends(CheckoutFinalizeOrderFormsResource, _super);
    function CheckoutFinalizeOrderFormsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckoutFinalizeOrderFormsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization_id) + "/checkout/bundles/orders/" + encodeURIComponent(params.number) + "/finalize",
            headers: params.headers,
            method: 'PUT',
        });
    };
    return CheckoutFinalizeOrderFormsResource;
}($Resource));
export { CheckoutFinalizeOrderFormsResource };
var CheckoutHttpSequencedRequestsResource = /** @class */ (function (_super) {
    __extends(CheckoutHttpSequencedRequestsResource, _super);
    function CheckoutHttpSequencedRequestsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckoutHttpSequencedRequestsResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/v2/checkout/sequenced/requests',
            headers: params.headers,
            method: 'GET',
            query: {
                checkout_id: params.checkout_id,
                id: params.id,
            },
        });
    };
    CheckoutHttpSequencedRequestsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/v2/checkout/sequenced/requests',
            headers: params.headers,
            method: 'POST',
        });
    };
    CheckoutHttpSequencedRequestsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/v2/checkout/sequenced/requests/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    return CheckoutHttpSequencedRequestsResource;
}($Resource));
export { CheckoutHttpSequencedRequestsResource };
var CheckoutHttpSequencedResponsesResource = /** @class */ (function (_super) {
    __extends(CheckoutHttpSequencedResponsesResource, _super);
    function CheckoutHttpSequencedResponsesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckoutHttpSequencedResponsesResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/v2/checkout/sequenced/responses',
            headers: params.headers,
            method: 'GET',
            query: {
                checkout_id: params.checkout_id,
                id: params.id,
                request_id: params.request_id,
            },
        });
    };
    return CheckoutHttpSequencedResponsesResource;
}($Resource));
export { CheckoutHttpSequencedResponsesResource };
var CheckoutSubmitOrderBundlesResource = /** @class */ (function (_super) {
    __extends(CheckoutSubmitOrderBundlesResource, _super);
    function CheckoutSubmitOrderBundlesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckoutSubmitOrderBundlesResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization_id) + "/checkout/bundles/orders/" + encodeURIComponent(params.number) + "/submit",
            headers: params.headers,
            method: 'PUT',
        });
    };
    return CheckoutSubmitOrderBundlesResource;
}($Resource));
export { CheckoutSubmitOrderBundlesResource };
var CiphersResource = /** @class */ (function (_super) {
    __extends(CiphersResource, _super);
    function CiphersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Encrypts a value and returns a reference to it.*/
    CiphersResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/cipher',
            headers: params.headers,
            method: 'POST',
        });
    };
    return CiphersResource;
}($Resource));
export { CiphersResource };
var ClassificationDetailsResource = /** @class */ (function (_super) {
    __extends(ClassificationDetailsResource, _super);
    function ClassificationDetailsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClassificationDetailsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/classification/details',
            headers: params.headers,
            method: 'GET',
            query: {
                date_from: params.date_from,
                date_to: params.date_to,
                limit: params.limit,
                offset: params.offset,
                organization_id: params.organization_id,
                product_id: params.product_id,
                updated_by_user_id: params.updated_by_user_id,
            },
        });
    };
    return ClassificationDetailsResource;
}($Resource));
export { ClassificationDetailsResource };
var ClassificationProductSummaryPagesResource = /** @class */ (function (_super) {
    __extends(ClassificationProductSummaryPagesResource, _super);
    function ClassificationProductSummaryPagesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClassificationProductSummaryPagesResource.prototype.getOrganizations = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/classification/organizations',
            headers: params.headers,
            method: 'GET',
        });
    };
    ClassificationProductSummaryPagesResource.prototype.getProducts = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/classification/products',
            headers: params.headers,
            method: 'GET',
            query: {
                cursor: params.cursor,
                organization: params.organization,
                status: params.status,
            },
        });
    };
    return ClassificationProductSummaryPagesResource;
}($Resource));
export { ClassificationProductSummaryPagesResource };
var ClassificationRequeueRequestsResource = /** @class */ (function (_super) {
    __extends(ClassificationRequeueRequestsResource, _super);
    function ClassificationRequeueRequestsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClassificationRequeueRequestsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/classification/requeue/request",
            headers: params.headers,
            method: 'POST',
            query: {
                limit: params.limit,
            },
        });
    };
    return ClassificationRequeueRequestsResource;
}($Resource));
export { ClassificationRequeueRequestsResource };
var ClassificationStatisticsResource = /** @class */ (function (_super) {
    __extends(ClassificationStatisticsResource, _super);
    function ClassificationStatisticsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Get statistics for items by harmonization status*/
    ClassificationStatisticsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/classification/statistics",
            headers: params.headers,
            method: 'GET',
        });
    };
    return ClassificationStatisticsResource;
}($Resource));
export { ClassificationStatisticsResource };
var ClassificationTaxonomyResource = /** @class */ (function (_super) {
    __extends(ClassificationTaxonomyResource, _super);
    function ClassificationTaxonomyResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClassificationTaxonomyResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/classification/taxonomy',
            headers: params.headers,
            method: 'GET',
        });
    };
    return ClassificationTaxonomyResource;
}($Resource));
export { ClassificationTaxonomyResource };
var CompliancesResource = /** @class */ (function (_super) {
    __extends(CompliancesResource, _super);
    function CompliancesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CompliancesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/harmonization/compliance",
            headers: params.headers,
            method: 'GET',
            query: {
                destination: params.destination,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                type: params.type,
            },
        });
    };
    CompliancesResource.prototype.getTypeAndDestinationByTypeAndDestination = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/harmonization/compliance/type/" + encodeURIComponent(params.type) + "/destination/" + encodeURIComponent(params.destination),
            headers: params.headers,
            method: 'GET',
        });
    };
    CompliancesResource.prototype.putTypeAndDestinationByTypeAndDestination = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/harmonization/compliance/type/" + encodeURIComponent(params.type) + "/destination/" + encodeURIComponent(params.destination),
            headers: params.headers,
            method: 'PUT',
        });
    };
    CompliancesResource.prototype.deleteTypeAndDestinationByTypeAndDestination = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/harmonization/compliance/type/" + encodeURIComponent(params.type) + "/destination/" + encodeURIComponent(params.destination),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return CompliancesResource;
}($Resource));
export { CompliancesResource };
var ConsumerOptinActivitiesResource = /** @class */ (function (_super) {
    __extends(ConsumerOptinActivitiesResource, _super);
    function ConsumerOptinActivitiesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConsumerOptinActivitiesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/optin/activities",
            headers: params.headers,
            method: 'POST',
        });
    };
    return ConsumerOptinActivitiesResource;
}($Resource));
export { ConsumerOptinActivitiesResource };
var ContentSchemasResource = /** @class */ (function (_super) {
    __extends(ContentSchemasResource, _super);
    function ContentSchemasResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContentSchemasResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/content/schemas',
            headers: params.headers,
            method: 'GET',
            query: {
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    ContentSchemasResource.prototype.getBySchemaKey = function (params) {
        return this.client.request({
            endpoint: "/content/schemas/" + encodeURIComponent(params.schema_key),
            headers: params.headers,
            method: 'GET',
        });
    };
    return ContentSchemasResource;
}($Resource));
export { ContentSchemasResource };
var CustomerSecretsResource = /** @class */ (function (_super) {
    __extends(CustomerSecretsResource, _super);
    function CustomerSecretsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomerSecretsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/internal/" + encodeURIComponent(params.organization) + "/customers/secret",
            headers: params.headers,
            method: 'GET',
        });
    };
    return CustomerSecretsResource;
}($Resource));
export { CustomerSecretsResource };
var CustomsDetailsResource = /** @class */ (function (_super) {
    __extends(CustomsDetailsResource, _super);
    function CustomsDetailsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns the customs details for the specified destination and item numbers.*/
    CustomsDetailsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/harmonization/customs/details",
            headers: params.headers,
            method: 'POST',
        });
    };
    return CustomsDetailsResource;
}($Resource));
export { CustomsDetailsResource };
var DeliveredDutyOptionsResource = /** @class */ (function (_super) {
    __extends(DeliveredDutyOptionsResource, _super);
    function DeliveredDutyOptionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns available options for shipping duty display preferences.*/
    DeliveredDutyOptionsResource.prototype.getOptionsAndV2 = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.key) + "/preference/display/shipping/duty/options/v2",
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
            },
        });
    };
    return DeliveredDutyOptionsResource;
}($Resource));
export { DeliveredDutyOptionsResource };
var DeliveredDutyPreferencesResource = /** @class */ (function (_super) {
    __extends(DeliveredDutyPreferencesResource, _super);
    function DeliveredDutyPreferencesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeliveredDutyPreferencesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.key) + "/preference/display/shipping/duty",
            headers: params.headers,
            method: 'GET',
        });
    };
    DeliveredDutyPreferencesResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.key) + "/preference/display/shipping/duty",
            headers: params.headers,
            method: 'PUT',
        });
    };
    return DeliveredDutyPreferencesResource;
}($Resource));
export { DeliveredDutyPreferencesResource };
var DiscountCodesResource = /** @class */ (function (_super) {
    __extends(DiscountCodesResource, _super);
    function DiscountCodesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Applies the discount code on the order, if valid*/
    DiscountCodesResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/discount/codes",
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
            },
        });
    };
    /*Removes the discount code from the order*/
    DiscountCodesResource.prototype.deleteByCode = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/discount/codes/" + encodeURIComponent(params.code),
            headers: params.headers,
            method: 'DELETE',
            query: {
                context: params.context,
            },
        });
    };
    return DiscountCodesResource;
}($Resource));
export { DiscountCodesResource };
var DutyInternalRatesResource = /** @class */ (function (_super) {
    __extends(DutyInternalRatesResource, _super);
    function DutyInternalRatesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DutyInternalRatesResource.prototype.getDestinationAndOriginByDestinationAndOrigin = function (params) {
        return this.client.request({
            endpoint: "/harmonization/rates/destination/" + encodeURIComponent(params.destination) + "/origin/" + encodeURIComponent(params.origin),
            headers: params.headers,
            method: 'GET',
            query: {
                hs6: params.hs6,
                id: params.id,
                limit: params.limit,
                name: params.name,
                offset: params.offset,
            },
        });
    };
    return DutyInternalRatesResource;
}($Resource));
export { DutyInternalRatesResource };
var ExperimentsResource = /** @class */ (function (_super) {
    __extends(ExperimentsResource, _super);
    function ExperimentsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExperimentsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiments",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                status: params.status,
            },
        });
    };
    /*Add an experiment*/
    ExperimentsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiments",
            headers: params.headers,
            method: 'POST',
        });
    };
    ExperimentsResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiments/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Upsert an experiment*/
    ExperimentsResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiments/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
        });
    };
    ExperimentsResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiments/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    /*Updates the status of an experiment*/
    ExperimentsResource.prototype.putByKeyAndStatus = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiments/" + encodeURIComponent(params.key) + "/" + encodeURIComponent(params.status),
            headers: params.headers,
            method: 'PUT',
            query: {
                activate_variant_id: params.activate_variant_id,
            },
        });
    };
    return ExperimentsResource;
}($Resource));
export { ExperimentsResource };
var ExperimentFormDefaultsResource = /** @class */ (function (_super) {
    __extends(ExperimentFormDefaultsResource, _super);
    function ExperimentFormDefaultsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*For the discriminator 'experience', returns the list of valid experience keys for which we can create an experiment. For the discriminator 'feature', returns the list of valid feature keys for which we can create an experiment*/
    ExperimentFormDefaultsResource.prototype.getDiscriminatorByDiscriminatorKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiment/form/defaults/discriminator/" + encodeURIComponent(params.discriminator_key),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Returns the defaults for the experiment form.*/
    ExperimentFormDefaultsResource.prototype.getDiscriminatorByDiscriminatorKeyAndValue = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiment/form/defaults/discriminator/" + encodeURIComponent(params.discriminator_key) + "/" + encodeURIComponent(params.value),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Returns*/
    ExperimentFormDefaultsResource.prototype.getByExperimentKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiment/form/defaults/" + encodeURIComponent(params.experiment_key),
            headers: params.headers,
            method: 'GET',
        });
    };
    return ExperimentFormDefaultsResource;
}($Resource));
export { ExperimentFormDefaultsResource };
var ExperimentResultsWithTimestampsResource = /** @class */ (function (_super) {
    __extends(ExperimentResultsWithTimestampsResource, _super);
    function ExperimentResultsWithTimestampsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExperimentResultsWithTimestampsResource.prototype.getCumulative = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiment/" + encodeURIComponent(params.key) + "/results/cumulative",
            headers: params.headers,
            method: 'GET',
            query: {
                end: params.end,
                start: params.start,
                timeseries: params.timeseries,
            },
        });
    };
    return ExperimentResultsWithTimestampsResource;
}($Resource));
export { ExperimentResultsWithTimestampsResource };
var FeaturesResource = /** @class */ (function (_super) {
    __extends(FeaturesResource, _super);
    function FeaturesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeaturesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/features",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                q: params.q,
                scope: params.scope,
                sort: params.sort,
                status: params.status,
            },
        });
    };
    FeaturesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/features",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Builds a query to search features*/
    FeaturesResource.prototype.postQueryAndBuilders = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/features/query/builders",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Builds a query related to a specific rule*/
    FeaturesResource.prototype.postRuleAndQueryAndBuilders = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/features/rule/query/builders",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Returns information about a specific user.*/
    FeaturesResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/features/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
        });
    };
    FeaturesResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/features/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
        });
    };
    FeaturesResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/features/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    FeaturesResource.prototype.putReleaseByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/features/" + encodeURIComponent(params.key) + "/release",
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Adds a rule to this feature. Position of rule will be last*/
    FeaturesResource.prototype.postRulesByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/features/" + encodeURIComponent(params.key) + "/rules",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Updates a rule*/
    FeaturesResource.prototype.putRulesByKeyAndId = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/features/" + encodeURIComponent(params.key) + "/rules/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Deletes the rule with the specified ID*/
    FeaturesResource.prototype.deleteRulesByKeyAndId = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/features/" + encodeURIComponent(params.key) + "/rules/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    FeaturesResource.prototype.putStatusByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/features/" + encodeURIComponent(params.key) + "/status",
            headers: params.headers,
            method: 'PUT',
        });
    };
    return FeaturesResource;
}($Resource));
export { FeaturesResource };
var FeatureValuesResource = /** @class */ (function (_super) {
    __extends(FeatureValuesResource, _super);
    function FeatureValuesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeatureValuesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/feature/values",
            headers: params.headers,
            method: 'POST',
        });
    };
    return FeatureValuesResource;
}($Resource));
export { FeatureValuesResource };
var FlowCurrencySettingsResource = /** @class */ (function (_super) {
    __extends(FlowCurrencySettingsResource, _super);
    function FlowCurrencySettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search Flow currency settings. Always paginated.*/
    FlowCurrencySettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/currency/settings',
            headers: params.headers,
            method: 'GET',
            query: {
                base: params.base,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                organization: params.organization,
                sort: params.sort,
                target: params.target,
            },
        });
    };
    /*Create Flow currency settings for an organization.*/
    FlowCurrencySettingsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/currency/settings',
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Provides visibility into recent changes of each object, including deletion.*/
    FlowCurrencySettingsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: '/internal/currency/settings/versions',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Get Flow currency settings.*/
    FlowCurrencySettingsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/currency/settings/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Update an existing Flow currency setting by id.*/
    FlowCurrencySettingsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/currency/settings/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return FlowCurrencySettingsResource;
}($Resource));
export { FlowCurrencySettingsResource };
var FlowLabProjectsResource = /** @class */ (function (_super) {
    __extends(FlowLabProjectsResource, _super);
    function FlowLabProjectsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FlowLabProjectsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/lab/projects',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    FlowLabProjectsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/lab/projects',
            headers: params.headers,
            method: 'POST',
        });
    };
    FlowLabProjectsResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/lab/projects/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
        });
    };
    FlowLabProjectsResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/lab/projects/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
        });
    };
    FlowLabProjectsResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/lab/projects/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return FlowLabProjectsResource;
}($Resource));
export { FlowLabProjectsResource };
var FlowLabelSettingsResource = /** @class */ (function (_super) {
    __extends(FlowLabelSettingsResource, _super);
    function FlowLabelSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FlowLabelSettingsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/label/settings',
            headers: params.headers,
            method: 'POST',
        });
    };
    FlowLabelSettingsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/label/settings/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    FlowLabelSettingsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/label/settings/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return FlowLabelSettingsResource;
}($Resource));
export { FlowLabelSettingsResource };
var FraudReviewsResource = /** @class */ (function (_super) {
    __extends(FraudReviewsResource, _super);
    function FraudReviewsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search fraud review. Always paginated.*/
    FraudReviewsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/fraud/reviews",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                order_number: params.order_number,
                sort: params.sort,
                status: params.status,
            },
        });
    };
    /*Provides visibility into recent changes of each object, including deletion*/
    FraudReviewsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/fraud/reviews/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                fraud_review_id: params.fraud_review_id,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                order_number: params.order_number,
                sort: params.sort,
            },
        });
    };
    FraudReviewsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/fraud/reviews/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    return FraudReviewsResource;
}($Resource));
export { FraudReviewsResource };
var FraudReviewDecisionsResource = /** @class */ (function (_super) {
    __extends(FraudReviewDecisionsResource, _super);
    function FraudReviewDecisionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Make decision on a fraud check pending review*/
    FraudReviewDecisionsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/fraud/reviews/" + encodeURIComponent(params.id) + "/decision",
            headers: params.headers,
            method: 'POST',
        });
    };
    return FraudReviewDecisionsResource;
}($Resource));
export { FraudReviewDecisionsResource };
var FtpSettingsResource = /** @class */ (function (_super) {
    __extends(FtpSettingsResource, _super);
    function FtpSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FtpSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization_id) + "/demandware/ftp-settings",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    FtpSettingsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization_id) + "/demandware/ftp-settings",
            headers: params.headers,
            method: 'POST',
        });
    };
    FtpSettingsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization_id) + "/demandware/ftp-settings/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    FtpSettingsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization_id) + "/demandware/ftp-settings/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    FtpSettingsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization_id) + "/demandware/ftp-settings/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return FtpSettingsResource;
}($Resource));
export { FtpSettingsResource };
var GiftCardProgramsResource = /** @class */ (function (_super) {
    __extends(GiftCardProgramsResource, _super);
    function GiftCardProgramsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GiftCardProgramsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/gift_cards",
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Adds a potential gift card. Will be rejected if this organization is not set up to manage gift cards or if the value of the gift card cannot be determined.*/
    GiftCardProgramsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/gift_cards",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
            },
        });
    };
    GiftCardProgramsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/gift_cards/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
            query: {
                context: params.context,
            },
        });
    };
    return GiftCardProgramsResource;
}($Resource));
export { GiftCardProgramsResource };
var GlobalSearchResultsResource = /** @class */ (function (_super) {
    __extends(GlobalSearchResultsResource, _super);
    function GlobalSearchResultsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GlobalSearchResultsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/search/global",
            headers: params.headers,
            method: 'GET',
            query: {
                q: params.q,
            },
        });
    };
    return GlobalSearchResultsResource;
}($Resource));
export { GlobalSearchResultsResource };
var GoogleShoppingSettingsResource = /** @class */ (function (_super) {
    __extends(GoogleShoppingSettingsResource, _super);
    function GoogleShoppingSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GoogleShoppingSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/settings/google",
            headers: params.headers,
            method: 'GET',
        });
    };
    GoogleShoppingSettingsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/settings/google",
            headers: params.headers,
            method: 'POST',
        });
    };
    return GoogleShoppingSettingsResource;
}($Resource));
export { GoogleShoppingSettingsResource };
var InternalHarmonizationStatisticsResource = /** @class */ (function (_super) {
    __extends(InternalHarmonizationStatisticsResource, _super);
    function InternalHarmonizationStatisticsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InternalHarmonizationStatisticsResource.prototype.getRateFreshness = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/harmonization/statistics/rate-freshness',
            headers: params.headers,
            method: 'GET',
            query: {
                destination: params.destination,
                from: params.from,
            },
        });
    };
    InternalHarmonizationStatisticsResource.prototype.getRateSource = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/harmonization/statistics/rate-source',
            headers: params.headers,
            method: 'GET',
            query: {
                destination: params.destination,
            },
        });
    };
    InternalHarmonizationStatisticsResource.prototype.getTimeToClassifyAggregated = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/harmonization/statistics/time-to-classify-aggregated',
            headers: params.headers,
            method: 'GET',
            query: {
                from: params.from,
                to: params.to,
            },
        });
    };
    InternalHarmonizationStatisticsResource.prototype.getTimeToClassify = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/harmonization/statistics/time-to-classify',
            headers: params.headers,
            method: 'GET',
            query: {
                from: params.from,
                to: params.to,
            },
        });
    };
    return InternalHarmonizationStatisticsResource;
}($Resource));
export { InternalHarmonizationStatisticsResource };
var InventoryOrganizationSettingsResource = /** @class */ (function (_super) {
    __extends(InventoryOrganizationSettingsResource, _super);
    function InventoryOrganizationSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InventoryOrganizationSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/inventory/settings",
            headers: params.headers,
            method: 'GET',
        });
    };
    InventoryOrganizationSettingsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/inventory/settings",
            headers: params.headers,
            method: 'POST',
        });
    };
    InventoryOrganizationSettingsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/inventory/settings",
            headers: params.headers,
            method: 'PUT',
        });
    };
    InventoryOrganizationSettingsResource.prototype.delete = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/inventory/settings",
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return InventoryOrganizationSettingsResource;
}($Resource));
export { InventoryOrganizationSettingsResource };
var NotificationRequestsResource = /** @class */ (function (_super) {
    __extends(NotificationRequestsResource, _super);
    function NotificationRequestsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotificationRequestsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/payment/callbacks/adyen',
            headers: params.headers,
            method: 'POST',
        });
    };
    return NotificationRequestsResource;
}($Resource));
export { NotificationRequestsResource };
var InvoiceWebhookResponsesResource = /** @class */ (function (_super) {
    __extends(InvoiceWebhookResponsesResource, _super);
    function InvoiceWebhookResponsesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InvoiceWebhookResponsesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/payment/callbacks/bitpay',
            headers: params.headers,
            method: 'POST',
        });
    };
    return InvoiceWebhookResponsesResource;
}($Resource));
export { InvoiceWebhookResponsesResource };
var CheckoutReferencesResource = /** @class */ (function (_super) {
    __extends(CheckoutReferencesResource, _super);
    function CheckoutReferencesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckoutReferencesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/checkout/references",
            headers: params.headers,
            method: 'POST',
        });
    };
    return CheckoutReferencesResource;
}($Resource));
export { CheckoutReferencesResource };
var UsersResource = /** @class */ (function (_super) {
    __extends(UsersResource, _super);
    function UsersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*List pending users*/
    UsersResource.prototype.getPending = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/internal/users/pending',
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Update the status of this particular user*/
    UsersResource.prototype.putStatusById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/users/" + encodeURIComponent(params.id) + "/status",
            headers: params.headers,
            method: 'PUT',
        });
    };
    return UsersResource;
}($Resource));
export { UsersResource };
var CryptoEventsResource = /** @class */ (function (_super) {
    __extends(CryptoEventsResource, _super);
    function CryptoEventsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CryptoEventsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/payment/callbacks/cryptopay',
            headers: params.headers,
            method: 'POST',
        });
    };
    return CryptoEventsResource;
}($Resource));
export { CryptoEventsResource };
var RatesResource = /** @class */ (function (_super) {
    __extends(RatesResource, _super);
    function RatesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Utility endpoint to quickly force republishing of an organization rates. For specified target or all target currencies.*/
    RatesResource.prototype.getInternal = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/currency/rates/internal",
            headers: params.headers,
            method: 'GET',
            query: {
                target: params.target,
            },
        });
    };
    return RatesResource;
}($Resource));
export { RatesResource };
var ExperiencesResource = /** @class */ (function (_super) {
    __extends(ExperiencesResource, _super);
    function ExperiencesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns localized information about 1 or more items given multiple filters. The filter is intended to match an item detail (e.g. number, attributes.product_id, attributes.brand).  The items will be localized based on the experience selected by the query parameters in the order of experience, then country, then ip address.*/
    ExperiencesResource.prototype.postItemsAndFilters = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/items/filters",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
                country: params.country,
                currency: params.currency,
                experience: params.experience,
                ip: params.ip,
                language: params.language,
                price_selector: params.price_selector,
                ship_from_country: params.ship_from_country,
                ship_from_province: params.ship_from_province,
                ship_to_country: params.ship_to_country,
                ship_to_province: params.ship_to_province,
                status: params.status,
            },
        });
    };
    /*Returns localized information about 1 or more items given a filter. The filter is intended to match an item detail (e.g. number, attributes.product_id, attributes.brand).  The items will be localized based on the experience selected by the query parameters in the order of experience, then country, then ip address.*/
    ExperiencesResource.prototype.postItemsAndFiltersByFilter = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/items/filters/" + encodeURIComponent(params.filter),
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
                country: params.country,
                currency: params.currency,
                experience: params.experience,
                ip: params.ip,
                language: params.language,
                price_selector: params.price_selector,
                ship_from_country: params.ship_from_country,
                ship_from_province: params.ship_from_province,
                ship_to_country: params.ship_to_country,
                ship_to_province: params.ship_to_province,
                status: params.status,
            },
        });
    };
    /*Returns localized information about 0 or more items given a query for the specified experience.*/
    ExperiencesResource.prototype.getItemsAndQueryByExperienceKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/items/query",
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
                country: params.country,
                currency: params.currency,
                q: params.q,
            },
        });
    };
    return ExperiencesResource;
}($Resource));
export { ExperiencesResource };
var OrdersResource = /** @class */ (function (_super) {
    __extends(OrdersResource, _super);
    function OrdersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrdersResource.prototype.getInternalByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/internal/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
                expand: params.expand,
            },
        });
    };
    /*Redeems all the gift card associated with an order. If a gift card fails, it is removed from the order and an error message is returned.*/
    OrdersResource.prototype.postGiftAndCardAndRedemptionsByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/gift/card/redemptions",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
            },
        });
    };
    /*Adds a gift card to the order*/
    OrdersResource.prototype.postGiftAndCardsByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/gift/cards",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
            },
        });
    };
    /*Removes a gift card from the order*/
    OrdersResource.prototype.deleteGiftAndCardsByNumberAndId = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/gift/cards/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
            query: {
                context: params.context,
            },
        });
    };
    /*Authorizes any credit payments associated with this order. Call prior to authorizing any credit payments to ensure the correct order balance is used. Any credit payments that fail will be removed.*/
    OrdersResource.prototype.postGiftCardsAndAuthorizeByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/gift_cards/authorize",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
            },
        });
    };
    /*Updates the email address associated with this order. Fixes typos automatically (e.g. gmail.con => gmail.com) or if not possible assigns a proxy email address to the order*/
    OrdersResource.prototype.putModificationsAndEmailByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/modifications/email",
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
            },
        });
    };
    /*Checks to see where an order can be submitted. Will not actually mark the order as submitted. Already submitted orders are given a free pass. This operation may perform some mutation if mutation is the only way to perform the check idempotently (e.g. checks to see if gift cards can be charged may actually charge the card).*/
    OrdersResource.prototype.putSubmissionsAndCheckByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/submissions/check",
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
            },
        });
    };
    return OrdersResource;
}($Resource));
export { OrdersResource };
var WebhookEventsResource = /** @class */ (function (_super) {
    __extends(WebhookEventsResource, _super);
    function WebhookEventsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WebhookEventsResource.prototype.postPaymentAndCallbacksAndPaypal = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/payment/callbacks/paypal',
            headers: params.headers,
            method: 'POST',
        });
    };
    WebhookEventsResource.prototype.postDisputeAndNotificationsAndPaypal = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/dispute/notifications/paypal',
            headers: params.headers,
            method: 'POST',
        });
    };
    return WebhookEventsResource;
}($Resource));
export { WebhookEventsResource };
var ReceiptNotificationsResource = /** @class */ (function (_super) {
    __extends(ReceiptNotificationsResource, _super);
    function ReceiptNotificationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReceiptNotificationsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/flexe/webhook/receipt',
            headers: params.headers,
            method: 'POST',
        });
    };
    return ReceiptNotificationsResource;
}($Resource));
export { ReceiptNotificationsResource };
var ShipmentNotificationsResource = /** @class */ (function (_super) {
    __extends(ShipmentNotificationsResource, _super);
    function ShipmentNotificationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShipmentNotificationsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/flexe/webhook/shipment',
            headers: params.headers,
            method: 'POST',
        });
    };
    return ShipmentNotificationsResource;
}($Resource));
export { ShipmentNotificationsResource };
var ReservationsResource = /** @class */ (function (_super) {
    __extends(ReservationsResource, _super);
    function ReservationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReservationsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/inventory/reservation",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
            },
        });
    };
    return ReservationsResource;
}($Resource));
export { ReservationsResource };
var OrderManagementEventsResource = /** @class */ (function (_super) {
    __extends(OrderManagementEventsResource, _super);
    function OrderManagementEventsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Order lifecycle events are designed to trigger exactly once automatically. This endpoint can be used to regenerate an event by customer request.*/
    OrderManagementEventsResource.prototype.postReplayByOrderLifecycleEvent = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/lifecycle/events/" + encodeURIComponent(params.order_lifecycle_event) + "/replay",
            headers: params.headers,
            method: 'POST',
        });
    };
    return OrderManagementEventsResource;
}($Resource));
export { OrderManagementEventsResource };
var OrganizationShortIdsResource = /** @class */ (function (_super) {
    __extends(OrganizationShortIdsResource, _super);
    function OrganizationShortIdsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrganizationShortIdsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization_id) + "/short_id",
            headers: params.headers,
            method: 'GET',
        });
    };
    OrganizationShortIdsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization_id) + "/short_id",
            headers: params.headers,
            method: 'POST',
        });
    };
    OrganizationShortIdsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization_id) + "/short_id",
            headers: params.headers,
            method: 'PUT',
        });
    };
    OrganizationShortIdsResource.prototype.delete = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization_id) + "/short_id",
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return OrganizationShortIdsResource;
}($Resource));
export { OrganizationShortIdsResource };
var AuthorizationsResource = /** @class */ (function (_super) {
    __extends(AuthorizationsResource, _super);
    function AuthorizationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Creates inline authorization parameters that are required in order to show payment methods like Paypal and Google Pay.*/
    AuthorizationsResource.prototype.postParameters = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/authorizations/parameters",
            headers: params.headers,
            method: 'POST',
        });
    };
    AuthorizationsResource.prototype.getMetadataByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/authorizations/" + encodeURIComponent(params.key) + "/metadata",
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Idempotently upserts an authorization's payload. For example, this endpoint can be used to complete a pending Apple Pay authorization by providing the payment token.*/
    AuthorizationsResource.prototype.putPayloadByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/authorizations/" + encodeURIComponent(params.key) + "/payload",
            headers: params.headers,
            method: 'PUT',
        });
    };
    AuthorizationsResource.prototype.postPaymentAndDetailsAndAdyenByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/authorizations/" + encodeURIComponent(params.key) + "/payment/details/adyen",
            headers: params.headers,
            method: 'POST',
        });
    };
    return AuthorizationsResource;
}($Resource));
export { AuthorizationsResource };
var PermissionAuditsResource = /** @class */ (function (_super) {
    __extends(PermissionAuditsResource, _super);
    function PermissionAuditsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*List all permitted routes and behaviors known to flow, along with the roles and authentication techniques that could be used to connect to them.*/
    PermissionAuditsResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/permission/audits',
            headers: params.headers,
            method: 'GET',
        });
    };
    return PermissionAuditsResource;
}($Resource));
export { PermissionAuditsResource };
var SimplePermissionChecksResource = /** @class */ (function (_super) {
    __extends(SimplePermissionChecksResource, _super);
    function SimplePermissionChecksResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns a 200 with any additional behaviors if the current request has access to the specified path or a 403 detailing the missing permissions and how to get them. Used by services to permit access.*/
    SimplePermissionChecksResource.prototype.getPermissionAndChecks = function (params) {
        return this.client.request({
            endpoint: '/permission/checks',
            headers: params.headers,
            method: 'GET',
            query: {
                path: params.path,
                verb: params.verb,
            },
        });
    };
    /*Returns a 200 with any additional behaviors if the current request has access to the specified path or a 403 detailing the missing permissions and how to get them. Used by services to permit access.*/
    SimplePermissionChecksResource.prototype.getPermissionAndChecksByOrganization = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/permission/checks",
            headers: params.headers,
            method: 'GET',
            query: {
                path: params.path,
                verb: params.verb,
            },
        });
    };
    return SimplePermissionChecksResource;
}($Resource));
export { SimplePermissionChecksResource };
var QueryBuildersResource = /** @class */ (function (_super) {
    __extends(QueryBuildersResource, _super);
    function QueryBuildersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QueryBuildersResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/query/builders",
            headers: params.headers,
            method: 'POST',
        });
    };
    return QueryBuildersResource;
}($Resource));
export { QueryBuildersResource };
var CountriesResource = /** @class */ (function (_super) {
    __extends(CountriesResource, _super);
    function CountriesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CountriesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/reports/destinations/countries",
            headers: params.headers,
            method: 'GET',
        });
    };
    return CountriesResource;
}($Resource));
export { CountriesResource };
var ContextsResource = /** @class */ (function (_super) {
    __extends(ContextsResource, _super);
    function ContextsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContextsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/contexts',
            headers: params.headers,
            method: 'POST',
        });
    };
    ContextsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/contexts/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    ContextsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/contexts/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ContextsResource;
}($Resource));
export { ContextsResource };
var OrganizationSessionsResource = /** @class */ (function (_super) {
    __extends(OrganizationSessionsResource, _super);
    function OrganizationSessionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrganizationSessionsResource.prototype.postOrganizationsByOrganization = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/sfcc/sessions/organizations/" + encodeURIComponent(params.organization),
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
            },
        });
    };
    OrganizationSessionsResource.prototype.getBySession = function (params) {
        return this.client.request({
            endpoint: "/sfcc/sessions/" + encodeURIComponent(params.session),
            headers: params.headers,
            method: 'GET',
        });
    };
    OrganizationSessionsResource.prototype.putBySession = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/sfcc/sessions/" + encodeURIComponent(params.session),
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
            },
        });
    };
    OrganizationSessionsResource.prototype.deleteBySession = function (params) {
        return this.client.request({
            endpoint: "/sfcc/sessions/" + encodeURIComponent(params.session),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    OrganizationSessionsResource.prototype.putOrganizationsBySessionAndOrganization = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/sfcc/sessions/" + encodeURIComponent(params.session) + "/organizations/" + encodeURIComponent(params.organization),
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
            },
        });
    };
    /*Resets the session based on the provided geo parameters.*/
    OrganizationSessionsResource.prototype.putResetBySession = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/sfcc/sessions/" + encodeURIComponent(params.session) + "/reset",
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
            },
        });
    };
    return OrganizationSessionsResource;
}($Resource));
export { OrganizationSessionsResource };
var ShopifyCartsResource = /** @class */ (function (_super) {
    __extends(ShopifyCartsResource, _super);
    function ShopifyCartsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Set the promotion code on the cart - shopify only supports up to 1 promotion code. If the cart already had another promotion code, replaces that code with the provided one.*/
    ShopifyCartsResource.prototype.putShopifyAndCartsAndPromotionById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/shopify/carts/" + encodeURIComponent(params.id) + "/promotion",
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
                expand: params.expand,
            },
        });
    };
    /*If the cart has a promotion code applied to it, removes that promotion code*/
    ShopifyCartsResource.prototype.deleteShopifyAndCartsAndPromotionById = function (params) {
        return this.client.request({
            endpoint: "/shopify/carts/" + encodeURIComponent(params.id) + "/promotion",
            headers: params.headers,
            method: 'DELETE',
            query: {
                context: params.context,
                expand: params.expand,
            },
        });
    };
    /*Create a shopify cart from a flow order*/
    ShopifyCartsResource.prototype.postShopifyAndCartsAndFlowAndOrderByOrganization = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/carts/flow/order",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
            },
        });
    };
    return ShopifyCartsResource;
}($Resource));
export { ShopifyCartsResource };
var ShopifyCartConversionsResource = /** @class */ (function (_super) {
    __extends(ShopifyCartConversionsResource, _super);
    function ShopifyCartConversionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Creates a checkout from a shopify cart*/
    ShopifyCartConversionsResource.prototype.postCheckouts = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/shopify/cart/checkouts",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
            },
        });
    };
    return ShopifyCartConversionsResource;
}($Resource));
export { ShopifyCartConversionsResource };
var ShopifyLocalizedVariantsResource = /** @class */ (function (_super) {
    __extends(ShopifyLocalizedVariantsResource, _super);
    function ShopifyLocalizedVariantsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShopifyLocalizedVariantsResource.prototype.getExperienceAndMapByExperienceKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/localized/variants/experience/" + encodeURIComponent(params.experience_key) + "/map",
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
                country: params.country,
                currency: params.currency,
                handle: params.handle,
                variant_id: params.variant_id,
            },
        });
    };
    return ShopifyLocalizedVariantsResource;
}($Resource));
export { ShopifyLocalizedVariantsResource };
var StripeEventsResource = /** @class */ (function (_super) {
    __extends(StripeEventsResource, _super);
    function StripeEventsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StripeEventsResource.prototype.postStripe = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/payment/callbacks/stripe',
            headers: params.headers,
            method: 'POST',
        });
    };
    return StripeEventsResource;
}($Resource));
export { StripeEventsResource };
var SvbNotificationsResource = /** @class */ (function (_super) {
    __extends(SvbNotificationsResource, _super);
    function SvbNotificationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SvbNotificationsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/payment/callbacks/svb',
            headers: params.headers,
            method: 'POST',
        });
    };
    return SvbNotificationsResource;
}($Resource));
export { SvbNotificationsResource };
var ItemClassificationsResource = /** @class */ (function (_super) {
    __extends(ItemClassificationsResource, _super);
    function ItemClassificationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItemClassificationsResource.prototype.postPredict = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/predict',
            headers: params.headers,
            method: 'POST',
        });
    };
    ItemClassificationsResource.prototype.postV2AndPredict = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/v2/predict',
            headers: params.headers,
            method: 'POST',
        });
    };
    return ItemClassificationsResource;
}($Resource));
export { ItemClassificationsResource };
var ItemClassificationSummariesResource = /** @class */ (function (_super) {
    __extends(ItemClassificationSummariesResource, _super);
    function ItemClassificationSummariesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Get item classifications*/
    ItemClassificationSummariesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/classification/item/summary",
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                number: params.number,
                offset: params.offset,
                sort: params.sort,
                status: params.status,
            },
        });
    };
    return ItemClassificationSummariesResource;
}($Resource));
export { ItemClassificationSummariesResource };
var ItemHarmonizationsResource = /** @class */ (function (_super) {
    __extends(ItemHarmonizationsResource, _super);
    function ItemHarmonizationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Get the latest harmonization results for the specified item numbers.*/
    ItemHarmonizationsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/harmonization/results/items",
            headers: params.headers,
            method: 'GET',
            query: {
                number: params.number,
            },
        });
    };
    return ItemHarmonizationsResource;
}($Resource));
export { ItemHarmonizationsResource };
var ItemRestrictionsResource = /** @class */ (function (_super) {
    __extends(ItemRestrictionsResource, _super);
    function ItemRestrictionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns a list of restricted items and the regions in which they are restricted.*/
    ItemRestrictionsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/item-restrictions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                number: params.number,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Restricts all items corresponding with the provided numbers in the provided regions.*/
    ItemRestrictionsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/item-restrictions",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*For the item with the provided number, updates the regions in which the item restriction applies.*/
    ItemRestrictionsResource.prototype.putItemByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/item-restrictions/item/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Deletes an item restriction by item number.*/
    ItemRestrictionsResource.prototype.deleteItemByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/item-restrictions/item/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    /*For the item restriction with the provided id, updates the regions in which the item restriction applies.*/
    ItemRestrictionsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/item-restrictions/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Deletes an item restriction by id.*/
    ItemRestrictionsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/item-restrictions/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ItemRestrictionsResource;
}($Resource));
export { ItemRestrictionsResource };
var ItemSalesMarginsResource = /** @class */ (function (_super) {
    __extends(ItemSalesMarginsResource, _super);
    function ItemSalesMarginsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItemSalesMarginsResource.prototype.getSalesMargins = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/sales-margins",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    ItemSalesMarginsResource.prototype.postSalesMargins = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/sales-margins",
            headers: params.headers,
            method: 'POST',
        });
    };
    ItemSalesMarginsResource.prototype.getSalesMarginsAndVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/sales-margins/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    ItemSalesMarginsResource.prototype.getSalesMarginsByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/sales-margins/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
        });
    };
    ItemSalesMarginsResource.prototype.putSalesMarginsByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/sales-margins/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
        });
    };
    ItemSalesMarginsResource.prototype.deleteSalesMarginsByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/sales-margins/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ItemSalesMarginsResource;
}($Resource));
export { ItemSalesMarginsResource };
var KeysResource = /** @class */ (function (_super) {
    __extends(KeysResource, _super);
    function KeysResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KeysResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/keys",
            headers: params.headers,
            method: 'GET',
        });
    };
    KeysResource.prototype.post = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/keys",
            headers: params.headers,
            method: 'POST',
        });
    };
    return KeysResource;
}($Resource));
export { KeysResource };
var LabProjectSettingsResource = /** @class */ (function (_super) {
    __extends(LabProjectSettingsResource, _super);
    function LabProjectSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LabProjectSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/lab/project/settings",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    LabProjectSettingsResource.prototype.getByFlowLabProjectKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/lab/project/settings/" + encodeURIComponent(params.flow_lab_project_key),
            headers: params.headers,
            method: 'GET',
        });
    };
    LabProjectSettingsResource.prototype.putByFlowLabProjectKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/lab/project/settings/" + encodeURIComponent(params.flow_lab_project_key),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return LabProjectSettingsResource;
}($Resource));
export { LabProjectSettingsResource };
var LabelGenerationSettingsResource = /** @class */ (function (_super) {
    __extends(LabelGenerationSettingsResource, _super);
    function LabelGenerationSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LabelGenerationSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/label/generation/settings",
            headers: params.headers,
            method: 'GET',
        });
    };
    LabelGenerationSettingsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/label/generation/settings",
            headers: params.headers,
            method: 'PUT',
        });
    };
    LabelGenerationSettingsResource.prototype.delete = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/label/generation/settings",
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return LabelGenerationSettingsResource;
}($Resource));
export { LabelGenerationSettingsResource };
var LabelTaxonomyResource = /** @class */ (function (_super) {
    __extends(LabelTaxonomyResource, _super);
    function LabelTaxonomyResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LabelTaxonomyResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/label_taxonomy',
            headers: params.headers,
            method: 'GET',
        });
    };
    return LabelTaxonomyResource;
}($Resource));
export { LabelTaxonomyResource };
var LiabilityRemittancePlansResource = /** @class */ (function (_super) {
    __extends(LiabilityRemittancePlansResource, _super);
    function LiabilityRemittancePlansResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LiabilityRemittancePlansResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/liabilities",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                order_number: params.order_number,
                sort: params.sort,
            },
        });
    };
    LiabilityRemittancePlansResource.prototype.getByOrderNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/liabilities/" + encodeURIComponent(params.order_number),
            headers: params.headers,
            method: 'GET',
        });
    };
    return LiabilityRemittancePlansResource;
}($Resource));
export { LiabilityRemittancePlansResource };
var LocalizableContentsResource = /** @class */ (function (_super) {
    __extends(LocalizableContentsResource, _super);
    function LocalizableContentsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Retreives blocks of translated content for the target schema and locale. If no localization exists for the target locale, the source content will be returned instead.*/
    LocalizableContentsResource.prototype.getContentAndSchemasBySchemaKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/content/schemas/" + encodeURIComponent(params.schema_key),
            headers: params.headers,
            method: 'GET',
            query: {
                cast: params.cast,
                language: params.language,
                locale: params.locale,
            },
        });
    };
    /*Retreives blocks of translated content for the target locale using a content id.  If no localization exists for the target locale, the source content will be returned instead.*/
    LocalizableContentsResource.prototype.getContentsAndLocalizationByContentId = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/contents/" + encodeURIComponent(params.content_id) + "/localization",
            headers: params.headers,
            method: 'GET',
            query: {
                cast: params.cast,
                language: params.language,
                locale: params.locale,
            },
        });
    };
    return LocalizableContentsResource;
}($Resource));
export { LocalizableContentsResource };
var LocalizationsResource = /** @class */ (function (_super) {
    __extends(LocalizationsResource, _super);
    function LocalizationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LocalizationsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/contents/" + encodeURIComponent(params.content_id) + "/localizations",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                locale: params.locale,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    LocalizationsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/contents/" + encodeURIComponent(params.content_id) + "/localizations/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Allows for patch updates to the value of a single block of translated content.*/
    LocalizationsResource.prototype.putElementsByIdAndKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/contents/" + encodeURIComponent(params.content_id) + "/localizations/" + encodeURIComponent(params.id) + "/elements/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return LocalizationsResource;
}($Resource));
export { LocalizationsResource };
var LocalizedContentsResource = /** @class */ (function (_super) {
    __extends(LocalizedContentsResource, _super);
    function LocalizedContentsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LocalizedContentsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/contents",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                schema_key: params.schema_key,
                sort: params.sort,
                status: params.status,
            },
        });
    };
    LocalizedContentsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/contents/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return LocalizedContentsResource;
}($Resource));
export { LocalizedContentsResource };
var LocalizedItemsExportSettingsResource = /** @class */ (function (_super) {
    __extends(LocalizedItemsExportSettingsResource, _super);
    function LocalizedItemsExportSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LocalizedItemsExportSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/settings/export/localized_items",
            headers: params.headers,
            method: 'GET',
        });
    };
    LocalizedItemsExportSettingsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/settings/export/localized_items",
            headers: params.headers,
            method: 'PUT',
        });
    };
    return LocalizedItemsExportSettingsResource;
}($Resource));
export { LocalizedItemsExportSettingsResource };
var LoyaltyProgramsResource = /** @class */ (function (_super) {
    __extends(LoyaltyProgramsResource, _super);
    function LoyaltyProgramsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoyaltyProgramsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/loyalty/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'GET',
        });
    };
    LoyaltyProgramsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/loyalty/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
            },
        });
    };
    LoyaltyProgramsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/loyalty/" + encodeURIComponent(params.number) + "/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
            query: {
                context: params.context,
            },
        });
    };
    return LoyaltyProgramsResource;
}($Resource));
export { LoyaltyProgramsResource };
var MarketingGatewayChannelsResource = /** @class */ (function (_super) {
    __extends(MarketingGatewayChannelsResource, _super);
    function MarketingGatewayChannelsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarketingGatewayChannelsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/gateway/channels",
            headers: params.headers,
            method: 'GET',
        });
    };
    MarketingGatewayChannelsResource.prototype.postNewChannelRequest = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/gateway/channels/new_channel_request",
            headers: params.headers,
            method: 'POST',
        });
    };
    MarketingGatewayChannelsResource.prototype.putConnectByChannelId = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/gateway/channels/" + encodeURIComponent(params.channel_id) + "/connect",
            headers: params.headers,
            method: 'PUT',
        });
    };
    MarketingGatewayChannelsResource.prototype.putDisconnectByChannelId = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/gateway/channels/" + encodeURIComponent(params.channel_id) + "/disconnect",
            headers: params.headers,
            method: 'PUT',
        });
    };
    MarketingGatewayChannelsResource.prototype.getFeedsAndDownloadsByChannelIdAndFeedAndFormat = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/gateway/channels/" + encodeURIComponent(params.channel_id) + "/feeds/" + encodeURIComponent(params.feed) + "/downloads/" + encodeURIComponent(params.format),
            headers: params.headers,
            method: 'GET',
        });
    };
    return MarketingGatewayChannelsResource;
}($Resource));
export { MarketingGatewayChannelsResource };
var MarketingGatewayChannelSourceSummariesResource = /** @class */ (function (_super) {
    __extends(MarketingGatewayChannelSourceSummariesResource, _super);
    function MarketingGatewayChannelSourceSummariesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarketingGatewayChannelSourceSummariesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/gateway/accounts",
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Registers a platform/account pair as a channel of interest for the purposes of creating localized feeds*/
    MarketingGatewayChannelSourceSummariesResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/gateway/accounts",
            headers: params.headers,
            method: 'PUT',
        });
    };
    return MarketingGatewayChannelSourceSummariesResource;
}($Resource));
export { MarketingGatewayChannelSourceSummariesResource };
var MarketingGatewayFacebookBusinessesResource = /** @class */ (function (_super) {
    __extends(MarketingGatewayFacebookBusinessesResource, _super);
    function MarketingGatewayFacebookBusinessesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarketingGatewayFacebookBusinessesResource.prototype.getCatalogs = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/gateway/facebook/" + encodeURIComponent(params.business_id) + "/catalogs",
            headers: params.headers,
            method: 'GET',
        });
    };
    return MarketingGatewayFacebookBusinessesResource;
}($Resource));
export { MarketingGatewayFacebookBusinessesResource };
var MarketingGatewayFacebookConnectionsResource = /** @class */ (function (_super) {
    __extends(MarketingGatewayFacebookConnectionsResource, _super);
    function MarketingGatewayFacebookConnectionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarketingGatewayFacebookConnectionsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/gateway/facebook",
            headers: params.headers,
            method: 'GET',
        });
    };
    MarketingGatewayFacebookConnectionsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/gateway/facebook",
            headers: params.headers,
            method: 'PUT',
        });
    };
    MarketingGatewayFacebookConnectionsResource.prototype.delete = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/gateway/facebook",
            headers: params.headers,
            method: 'DELETE',
        });
    };
    MarketingGatewayFacebookConnectionsResource.prototype.putCatalog = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/gateway/facebook/catalog",
            headers: params.headers,
            method: 'PUT',
        });
    };
    return MarketingGatewayFacebookConnectionsResource;
}($Resource));
export { MarketingGatewayFacebookConnectionsResource };
var MarketingGatewayFacebookConnectionAccessTokenSummariesResource = /** @class */ (function (_super) {
    __extends(MarketingGatewayFacebookConnectionAccessTokenSummariesResource, _super);
    function MarketingGatewayFacebookConnectionAccessTokenSummariesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarketingGatewayFacebookConnectionAccessTokenSummariesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/gateway/facebook/access_token_summary",
            headers: params.headers,
            method: 'GET',
        });
    };
    return MarketingGatewayFacebookConnectionAccessTokenSummariesResource;
}($Resource));
export { MarketingGatewayFacebookConnectionAccessTokenSummariesResource };
var MarketingGatewayFacebookConnectionDeauthsResource = /** @class */ (function (_super) {
    __extends(MarketingGatewayFacebookConnectionDeauthsResource, _super);
    function MarketingGatewayFacebookConnectionDeauthsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarketingGatewayFacebookConnectionDeauthsResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/marketing/gateway/facebook/deauth',
            headers: params.headers,
            method: 'GET',
        });
    };
    MarketingGatewayFacebookConnectionDeauthsResource.prototype.post = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/marketing/gateway/facebook/deauth',
            headers: params.headers,
            method: 'POST',
            query: {
                signed_request: params.signed_request,
            },
        });
    };
    return MarketingGatewayFacebookConnectionDeauthsResource;
}($Resource));
export { MarketingGatewayFacebookConnectionDeauthsResource };
var MarketingGatewayFeedsResource = /** @class */ (function (_super) {
    __extends(MarketingGatewayFeedsResource, _super);
    function MarketingGatewayFeedsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarketingGatewayFeedsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/gateway/feeds",
            headers: params.headers,
            method: 'GET',
            query: {
                channel_id: params.channel_id,
                schema_compatibility: params.schema_compatibility,
            },
        });
    };
    MarketingGatewayFeedsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/gateway/feeds",
            headers: params.headers,
            method: 'POST',
        });
    };
    MarketingGatewayFeedsResource.prototype.postBulk = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/gateway/feeds/bulk",
            headers: params.headers,
            method: 'POST',
        });
    };
    MarketingGatewayFeedsResource.prototype.postExport = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/gateway/feeds/export",
            headers: params.headers,
            method: 'POST',
        });
    };
    MarketingGatewayFeedsResource.prototype.getByFeed = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/gateway/feeds/" + encodeURIComponent(params.feed),
            headers: params.headers,
            method: 'GET',
        });
    };
    MarketingGatewayFeedsResource.prototype.deleteByFeed = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/gateway/feeds/" + encodeURIComponent(params.feed),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    MarketingGatewayFeedsResource.prototype.getDownloadsByFeedAndFormat = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/gateway/feeds/" + encodeURIComponent(params.feed) + "/downloads/" + encodeURIComponent(params.format),
            headers: params.headers,
            method: 'GET',
        });
    };
    return MarketingGatewayFeedsResource;
}($Resource));
export { MarketingGatewayFeedsResource };
var MarketingGatewayFeedFormsResource = /** @class */ (function (_super) {
    __extends(MarketingGatewayFeedFormsResource, _super);
    function MarketingGatewayFeedFormsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Provides list of feed forms (for markets) that do not yet exist and therefore can be created.*/
    MarketingGatewayFeedFormsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/gateway/feed/forms",
            headers: params.headers,
            method: 'POST',
        });
    };
    return MarketingGatewayFeedFormsResource;
}($Resource));
export { MarketingGatewayFeedFormsResource };
var MarketingGatewayFeedSourcesResource = /** @class */ (function (_super) {
    __extends(MarketingGatewayFeedSourcesResource, _super);
    function MarketingGatewayFeedSourcesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Provides list of data sources that can be used to create feeds from.*/
    MarketingGatewayFeedSourcesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/gateway/feed/sources",
            headers: params.headers,
            method: 'GET',
            query: {
                channel_id: params.channel_id,
            },
        });
    };
    return MarketingGatewayFeedSourcesResource;
}($Resource));
export { MarketingGatewayFeedSourcesResource };
var MarketingGatewayGoogleConnectionsResource = /** @class */ (function (_super) {
    __extends(MarketingGatewayGoogleConnectionsResource, _super);
    function MarketingGatewayGoogleConnectionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarketingGatewayGoogleConnectionsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/gateway/google",
            headers: params.headers,
            method: 'GET',
        });
    };
    MarketingGatewayGoogleConnectionsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/gateway/google",
            headers: params.headers,
            method: 'PUT',
        });
    };
    MarketingGatewayGoogleConnectionsResource.prototype.delete = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/gateway/google",
            headers: params.headers,
            method: 'DELETE',
        });
    };
    MarketingGatewayGoogleConnectionsResource.prototype.putAccount = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/gateway/google/account",
            headers: params.headers,
            method: 'PUT',
        });
    };
    return MarketingGatewayGoogleConnectionsResource;
}($Resource));
export { MarketingGatewayGoogleConnectionsResource };
var MarketingGatewayLocalizedItemsResource = /** @class */ (function (_super) {
    __extends(MarketingGatewayLocalizedItemsResource, _super);
    function MarketingGatewayLocalizedItemsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Provides random list of localized items given a feed form.*/
    MarketingGatewayLocalizedItemsResource.prototype.postRandom = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/gateway/items/random",
            headers: params.headers,
            method: 'POST',
            query: {
                limit: params.limit,
            },
        });
    };
    return MarketingGatewayLocalizedItemsResource;
}($Resource));
export { MarketingGatewayLocalizedItemsResource };
var MerchantOfRecordEntitySettingsResource = /** @class */ (function (_super) {
    __extends(MerchantOfRecordEntitySettingsResource, _super);
    function MerchantOfRecordEntitySettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MerchantOfRecordEntitySettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/merchant-of-record-entity",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                names: params.names,
                offset: params.offset,
                sort: params.sort,
                starts_at: params.starts_at,
            },
        });
    };
    MerchantOfRecordEntitySettingsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/merchant-of-record-entity",
            headers: params.headers,
            method: 'POST',
        });
    };
    MerchantOfRecordEntitySettingsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/merchant-of-record-entity/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    MerchantOfRecordEntitySettingsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/merchant-of-record-entity/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    MerchantOfRecordEntitySettingsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/merchant-of-record-entity/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return MerchantOfRecordEntitySettingsResource;
}($Resource));
export { MerchantOfRecordEntitySettingsResource };
var NotificationsResource = /** @class */ (function (_super) {
    __extends(NotificationsResource, _super);
    function NotificationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Riskified decision notification.*/
    NotificationsResource.prototype.postRiskified = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/fraud/notifications/riskified',
            headers: params.headers,
            method: 'POST',
        });
    };
    return NotificationsResource;
}($Resource));
export { NotificationsResource };
var OptinAttributesResource = /** @class */ (function (_super) {
    __extends(OptinAttributesResource, _super);
    function OptinAttributesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OptinAttributesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/optin/attributes",
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                offset: params.offset,
                optin_attribute_key: params.optin_attribute_key,
                sort: params.sort,
            },
        });
    };
    OptinAttributesResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/optin/attributes/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
        });
    };
    OptinAttributesResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/optin/attributes/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
        });
    };
    OptinAttributesResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/optin/attributes/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return OptinAttributesResource;
}($Resource));
export { OptinAttributesResource };
var OptinPromptsResource = /** @class */ (function (_super) {
    __extends(OptinPromptsResource, _super);
    function OptinPromptsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OptinPromptsResource.prototype.getPrompts = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/optin/prompts",
            headers: params.headers,
            method: 'GET',
            query: {
                expand: params.expand,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                optin_attribute_key: params.optin_attribute_key,
                region: params.region,
                sort: params.sort,
            },
        });
    };
    OptinPromptsResource.prototype.postPrompts = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/optin/prompts",
            headers: params.headers,
            method: 'POST',
        });
    };
    OptinPromptsResource.prototype.putPromptsById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/optin/prompts/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    OptinPromptsResource.prototype.deletePromptsById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/optin/prompts/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    /*This anonymous path will allow consumers to receive a targeted list of prompts that should apply in their region.*/
    OptinPromptsResource.prototype.getTargetsByTargetAndRegion = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/optin/targets/" + encodeURIComponent(params.target) + "/" + encodeURIComponent(params.region),
            headers: params.headers,
            method: 'GET',
            query: {
                cast: params.cast,
                expand: params.expand,
                language: params.language,
                locale: params.locale,
            },
        });
    };
    OptinPromptsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/optin/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
            query: {
                expand: params.expand,
            },
        });
    };
    return OptinPromptsResource;
}($Resource));
export { OptinPromptsResource };
var OptinPromptCopiesResource = /** @class */ (function (_super) {
    __extends(OptinPromptCopiesResource, _super);
    function OptinPromptCopiesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Copies all active opt-ins along with their content and translations from the source org to each of the orgs specified in the body. If the current user does not have permissions to create content for one of these orgs, this will result in a 422. Other orgs will complete.*/
    OptinPromptCopiesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/optin/prompt/copies',
            headers: params.headers,
            method: 'POST',
        });
    };
    return OptinPromptCopiesResource;
}($Resource));
export { OptinPromptCopiesResource };
var OrderActionabilitiesResource = /** @class */ (function (_super) {
    __extends(OrderActionabilitiesResource, _super);
    function OrderActionabilitiesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Attempts to take an action or set of line quantity actions on an order.*/
    OrderActionabilitiesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/status/actions",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Returns the current actionability for this order*/
    OrderActionabilitiesResource.prototype.getAvailable = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/status/actions/available",
            headers: params.headers,
            method: 'GET',
        });
    };
    return OrderActionabilitiesResource;
}($Resource));
export { OrderActionabilitiesResource };
var OrderDetailsResource = /** @class */ (function (_super) {
    __extends(OrderDetailsResource, _super);
    function OrderDetailsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns order information*/
    OrderDetailsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/order-details",
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                offset: params.offset,
                q: params.q,
            },
        });
    };
    /*Returns order information for a specific number*/
    OrderDetailsResource.prototype.getByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/order-details/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'GET',
        });
    };
    return OrderDetailsResource;
}($Resource));
export { OrderDetailsResource };
var OrderPaymentAuthorizationsResource = /** @class */ (function (_super) {
    __extends(OrderPaymentAuthorizationsResource, _super);
    function OrderPaymentAuthorizationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Create a new authorization for this order.*/
    OrderPaymentAuthorizationsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/order/payments/authorization",
            headers: params.headers,
            method: 'POST',
            query: {
                expand: params.expand,
            },
        });
    };
    return OrderPaymentAuthorizationsResource;
}($Resource));
export { OrderPaymentAuthorizationsResource };
var OrderRevenueRegionChartsResource = /** @class */ (function (_super) {
    __extends(OrderRevenueRegionChartsResource, _super);
    function OrderRevenueRegionChartsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrderRevenueRegionChartsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/reports/revenue/regions",
            headers: params.headers,
            method: 'GET',
            query: {
                after: params.after,
                before: params.before,
                on_or_after: params.on_or_after,
                on_or_before: params.on_or_before,
                regions: params.regions,
                timezone: params.timezone,
            },
        });
    };
    return OrderRevenueRegionChartsResource;
}($Resource));
export { OrderRevenueRegionChartsResource };
var OrderRevenueTimelineChartsResource = /** @class */ (function (_super) {
    __extends(OrderRevenueTimelineChartsResource, _super);
    function OrderRevenueTimelineChartsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrderRevenueTimelineChartsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/reports/revenue/timeline",
            headers: params.headers,
            method: 'GET',
            query: {
                after: params.after,
                before: params.before,
                interval: params.interval,
                on_or_after: params.on_or_after,
                on_or_before: params.on_or_before,
                region: params.region,
                timezone: params.timezone,
            },
        });
    };
    return OrderRevenueTimelineChartsResource;
}($Resource));
export { OrderRevenueTimelineChartsResource };
var OrganizationMembershipCopiesResource = /** @class */ (function (_super) {
    __extends(OrganizationMembershipCopiesResource, _super);
    function OrganizationMembershipCopiesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrganizationMembershipCopiesResource.prototype.postMembershipAndCopies = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/organization/membership/copies',
            headers: params.headers,
            method: 'POST',
        });
    };
    return OrganizationMembershipCopiesResource;
}($Resource));
export { OrganizationMembershipCopiesResource };
var OrganizationSettingsResource = /** @class */ (function (_super) {
    __extends(OrganizationSettingsResource, _super);
    function OrganizationSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrganizationSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experience/settings",
            headers: params.headers,
            method: 'GET',
        });
    };
    OrganizationSettingsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/experience/settings",
            headers: params.headers,
            method: 'PUT',
        });
    };
    return OrganizationSettingsResource;
}($Resource));
export { OrganizationSettingsResource };
var PartnersResource = /** @class */ (function (_super) {
    __extends(PartnersResource, _super);
    function PartnersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PartnersResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/internal/partners',
            headers: params.headers,
            method: 'POST',
        });
    };
    PartnersResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/partners/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    PartnersResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/internal/partners/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return PartnersResource;
}($Resource));
export { PartnersResource };
var PartnerAuthorizationsResource = /** @class */ (function (_super) {
    __extends(PartnerAuthorizationsResource, _super);
    function PartnerAuthorizationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*For the authorized user, if the specified partner exists, and the user is an active member of this partner, returns the authorization data used throughout APIs at Flow, including the user's role in that organization and the partner environment. Otherwise, returns 401 - this indicates either the org does not exist or the user does not have access to the partner.*/
    PartnerAuthorizationsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/partner-authorizations',
            headers: params.headers,
            method: 'POST',
        });
    };
    /*For the authorized user and specific partner, if the user is an active member of this partner, returns the authorization data used throughout APIs at Flow, including the user's role in that partner and the partner environment.*/
    PartnerAuthorizationsResource.prototype.getByPartner = function (params) {
        return this.client.request({
            endpoint: "/partner-authorizations/" + encodeURIComponent(params.partner),
            headers: params.headers,
            method: 'GET',
        });
    };
    return PartnerAuthorizationsResource;
}($Resource));
export { PartnerAuthorizationsResource };
var PartnerMembershipsResource = /** @class */ (function (_super) {
    __extends(PartnerMembershipsResource, _super);
    function PartnerMembershipsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PartnerMembershipsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/partners/" + encodeURIComponent(params.partner) + "/memberships",
            headers: params.headers,
            method: 'GET',
            query: {
                expand: params.expand,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                role: params.role,
                sort: params.sort,
                user: params.user,
            },
        });
    };
    PartnerMembershipsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/partners/" + encodeURIComponent(params.partner) + "/memberships",
            headers: params.headers,
            method: 'POST',
        });
    };
    PartnerMembershipsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/partners/" + encodeURIComponent(params.partner) + "/memberships/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                membership: params.membership,
                offset: params.offset,
                sort: params.sort,
                user: params.user,
            },
        });
    };
    PartnerMembershipsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/partners/" + encodeURIComponent(params.partner) + "/memberships/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    PartnerMembershipsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/partners/" + encodeURIComponent(params.partner) + "/memberships/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    PartnerMembershipsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/partners/" + encodeURIComponent(params.partner) + "/memberships/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return PartnerMembershipsResource;
}($Resource));
export { PartnerMembershipsResource };
var PartnerOrganizationAuthorizationsResource = /** @class */ (function (_super) {
    __extends(PartnerOrganizationAuthorizationsResource, _super);
    function PartnerOrganizationAuthorizationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PartnerOrganizationAuthorizationsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/partner-organization-authorizations",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                partner: params.partner,
                sort: params.sort,
            },
        });
    };
    PartnerOrganizationAuthorizationsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/partner-organization-authorizations",
            headers: params.headers,
            method: 'POST',
        });
    };
    PartnerOrganizationAuthorizationsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/partner-organization-authorizations/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    PartnerOrganizationAuthorizationsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/partner-organization-authorizations/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return PartnerOrganizationAuthorizationsResource;
}($Resource));
export { PartnerOrganizationAuthorizationsResource };
var PassphrasesResource = /** @class */ (function (_super) {
    __extends(PassphrasesResource, _super);
    function PassphrasesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PassphrasesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/passphrases",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                tribe: params.tribe,
            },
        });
    };
    /*Creates a new passphrase for a given tribe.*/
    PassphrasesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/passphrases",
            headers: params.headers,
            method: 'POST',
        });
    };
    PassphrasesResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/passphrases/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Used to provide the cleartext password for a given passphrase.*/
    PassphrasesResource.prototype.postAuthenticationsById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/passphrases/" + encodeURIComponent(params.id) + "/authentications",
            headers: params.headers,
            method: 'POST',
        });
    };
    return PassphrasesResource;
}($Resource));
export { PassphrasesResource };
var PaymentOrganizationSettingsResource = /** @class */ (function (_super) {
    __extends(PaymentOrganizationSettingsResource, _super);
    function PaymentOrganizationSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Retrieves payment settings for a given organization.*/
    PaymentOrganizationSettingsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/internal/organization/settings/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Onboards or updates payment settings for an existing organization.*/
    PaymentOrganizationSettingsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/organization/settings/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return PaymentOrganizationSettingsResource;
}($Resource));
export { PaymentOrganizationSettingsResource };
var PaymentRedirectsResource = /** @class */ (function (_super) {
    __extends(PaymentRedirectsResource, _super);
    function PaymentRedirectsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Redirects to the appropriate success or failure URL corresponding with the given authorization, if it exists.*/
    PaymentRedirectsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/payment/redirects/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
            query: {
                authResult: params.authResult,
                merchantReference: params.merchantReference,
                merchantSig: params.merchantSig,
                paymentMethod: params.paymentMethod,
                pspReference: params.pspReference,
                shopperLocale: params.shopperLocale,
                skinCode: params.skinCode,
            },
        });
    };
    /*Redirects to the appropriate success or failure URL corresponding with the given authorization, if it exists. A POST endpoint is required for 3D Secure through Adyen.*/
    PaymentRedirectsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/payment/redirects/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'POST',
        });
    };
    return PaymentRedirectsResource;
}($Resource));
export { PaymentRedirectsResource };
var PendingBankPaymentsResource = /** @class */ (function (_super) {
    __extends(PendingBankPaymentsResource, _super);
    function PendingBankPaymentsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PendingBankPaymentsResource.prototype.getPending = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/internal/bank/payment/pending',
            headers: params.headers,
            method: 'GET',
            query: {
                account_id: params.account_id,
                organization: params.organization,
            },
        });
    };
    return PendingBankPaymentsResource;
}($Resource));
export { PendingBankPaymentsResource };
var PlatformFeeChangesResource = /** @class */ (function (_super) {
    __extends(PlatformFeeChangesResource, _super);
    function PlatformFeeChangesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PlatformFeeChangesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/internal/" + encodeURIComponent(params.organization) + "/platform_fee_changes",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    PlatformFeeChangesResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/internal/" + encodeURIComponent(params.organization) + "/platform_fee_changes/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
        });
    };
    PlatformFeeChangesResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/internal/" + encodeURIComponent(params.organization) + "/platform_fee_changes/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
        });
    };
    PlatformFeeChangesResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/internal/" + encodeURIComponent(params.organization) + "/platform_fee_changes/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return PlatformFeeChangesResource;
}($Resource));
export { PlatformFeeChangesResource };
var ProcessorAccountsResource = /** @class */ (function (_super) {
    __extends(ProcessorAccountsResource, _super);
    function ProcessorAccountsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Retrieves details about all onboarded accounts for a given payment processor. This is most useful for processors like Adyen, Fiserv, and Stripe that have platform level accounts.*/
    ProcessorAccountsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/processors/" + encodeURIComponent(params.processor) + "/accounts",
            headers: params.headers,
            method: 'GET',
            query: {
                country: params.country,
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                organization: params.organization,
                owner: params.owner,
                sort: params.sort,
                status: params.status,
            },
        });
    };
    /*Retrieves details about an account with a processor.*/
    ProcessorAccountsResource.prototype.getByOrganizationAndKey = function (params) {
        return this.client.request({
            endpoint: "/processors/" + encodeURIComponent(params.processor) + "/accounts/" + encodeURIComponent(params.organization) + "/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Onboards or updates an existing account for a given payment processor on to Flow.*/
    ProcessorAccountsResource.prototype.putByOrganizationAndKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/processors/" + encodeURIComponent(params.processor) + "/accounts/" + encodeURIComponent(params.organization) + "/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Updates the status of an existing account for a given payment processor on to Flow.*/
    ProcessorAccountsResource.prototype.putModificationsByOrganizationAndKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/processors/" + encodeURIComponent(params.processor) + "/accounts/" + encodeURIComponent(params.organization) + "/" + encodeURIComponent(params.key) + "/modifications",
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Updates details about a payment processor account.*/
    ProcessorAccountsResource.prototype.putModificationsAndStatusByOrganizationAndKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/processors/" + encodeURIComponent(params.processor) + "/accounts/" + encodeURIComponent(params.organization) + "/" + encodeURIComponent(params.key) + "/modifications/status",
            headers: params.headers,
            method: 'PUT',
        });
    };
    return ProcessorAccountsResource;
}($Resource));
export { ProcessorAccountsResource };
var ProcessorMerchantsResource = /** @class */ (function (_super) {
    __extends(ProcessorMerchantsResource, _super);
    function ProcessorMerchantsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Retrieves details about all onboarded merchants under a given payment processor account.*/
    ProcessorMerchantsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/processors/" + encodeURIComponent(params.processor) + "/accounts/" + encodeURIComponent(params.account_organization) + "/" + encodeURIComponent(params.account_key) + "/merchants",
            headers: params.headers,
            method: 'GET',
            query: {
                country: params.country,
                external_id: params.external_id,
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                organization: params.organization,
                sort: params.sort,
                status: params.status,
            },
        });
    };
    /*Creates a new merchant under an existing payment processor account and onboards it to Flow. Currently not functional for any processor.*/
    ProcessorMerchantsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/processors/" + encodeURIComponent(params.processor) + "/accounts/" + encodeURIComponent(params.account_organization) + "/" + encodeURIComponent(params.account_key) + "/merchants",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Retrieves details about an onboarded merchant under an onboarded payment procesor account.*/
    ProcessorMerchantsResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/processors/" + encodeURIComponent(params.processor) + "/accounts/" + encodeURIComponent(params.account_organization) + "/" + encodeURIComponent(params.account_key) + "/merchants/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Onboards or updates an existing merchant under an existing payment processor account.*/
    ProcessorMerchantsResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/processors/" + encodeURIComponent(params.processor) + "/accounts/" + encodeURIComponent(params.account_organization) + "/" + encodeURIComponent(params.account_key) + "/merchants/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Updates details about a merchant under a payment processor account.*/
    ProcessorMerchantsResource.prototype.putModificationsByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/processors/" + encodeURIComponent(params.processor) + "/accounts/" + encodeURIComponent(params.account_organization) + "/" + encodeURIComponent(params.account_key) + "/merchants/" + encodeURIComponent(params.key) + "/modifications",
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Updates an existing merchant's status.*/
    ProcessorMerchantsResource.prototype.putModificationsAndStatusByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/processors/" + encodeURIComponent(params.processor) + "/accounts/" + encodeURIComponent(params.account_organization) + "/" + encodeURIComponent(params.account_key) + "/merchants/" + encodeURIComponent(params.key) + "/modifications/status",
            headers: params.headers,
            method: 'PUT',
        });
    };
    return ProcessorMerchantsResource;
}($Resource));
export { ProcessorMerchantsResource };
var ProductClassificationsResource = /** @class */ (function (_super) {
    __extends(ProductClassificationsResource, _super);
    function ProductClassificationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductClassificationsResource.prototype.postHarmonizeLabels = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/product_classifications/harmonize_labels',
            headers: params.headers,
            method: 'POST',
        });
    };
    ProductClassificationsResource.prototype.getOrganizationAndProductByOrganizationIdAndProductId = function (params) {
        return this.client.request({
            endpoint: "/product_classifications/organization/" + encodeURIComponent(params.organization_id) + "/product/" + encodeURIComponent(params.product_id),
            headers: params.headers,
            method: 'GET',
            query: {
                next_product_id_filter_by_organization: params.next_product_id_filter_by_organization,
            },
        });
    };
    ProductClassificationsResource.prototype.postOrganizationAndProductByOrganizationIdAndProductId = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/product_classifications/organization/" + encodeURIComponent(params.organization_id) + "/product/" + encodeURIComponent(params.product_id),
            headers: params.headers,
            method: 'POST',
        });
    };
    ProductClassificationsResource.prototype.getRefreshDefaultHs6 = function (params) {
        return this.client.request({
            endpoint: '/product_classifications/refresh_default_hs6',
            headers: params.headers,
            method: 'GET',
            query: {
                dry_run: params.dry_run,
            },
        });
    };
    return ProductClassificationsResource;
}($Resource));
export { ProductClassificationsResource };
var RatecardStandardConfigurationsResource = /** @class */ (function (_super) {
    __extends(RatecardStandardConfigurationsResource, _super);
    function RatecardStandardConfigurationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RatecardStandardConfigurationsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/ratecard/standard/configurations",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                source_ratecard_number: params.source_ratecard_number,
                source_ratecard_organization: params.source_ratecard_organization,
            },
        });
    };
    RatecardStandardConfigurationsResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/ratecard/standard/configurations/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
        });
    };
    RatecardStandardConfigurationsResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/ratecard/standard/configurations/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
        });
    };
    RatecardStandardConfigurationsResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/ratecard/standard/configurations/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return RatecardStandardConfigurationsResource;
}($Resource));
export { RatecardStandardConfigurationsResource };
var RatesNamesSummariesResource = /** @class */ (function (_super) {
    __extends(RatesNamesSummariesResource, _super);
    function RatesNamesSummariesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns a summary of the rate names that apply.*/
    RatesNamesSummariesResource.prototype.getDestinationAndOriginByDestinationAndOrigin = function (params) {
        return this.client.request({
            endpoint: "/harmonization/rates/names/summaries/destination/" + encodeURIComponent(params.destination) + "/origin/" + encodeURIComponent(params.origin),
            headers: params.headers,
            method: 'GET',
        });
    };
    return RatesNamesSummariesResource;
}($Resource));
export { RatesNamesSummariesResource };
var ReboundConfigurationsResource = /** @class */ (function (_super) {
    __extends(ReboundConfigurationsResource, _super);
    function ReboundConfigurationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReboundConfigurationsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/rebound/configuration",
            headers: params.headers,
            method: 'GET',
        });
    };
    ReboundConfigurationsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/rebound/configuration",
            headers: params.headers,
            method: 'PUT',
        });
    };
    ReboundConfigurationsResource.prototype.delete = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/rebound/configuration",
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ReboundConfigurationsResource;
}($Resource));
export { ReboundConfigurationsResource };
var RoutingEntitiesResource = /** @class */ (function (_super) {
    __extends(RoutingEntitiesResource, _super);
    function RoutingEntitiesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Retrieves details about all potential payment routing options based on the provided parameters. This will exclude top level accounts that cannot process transactions without a valid merchant - they would be included if any of their merchants are eligible. All querystrings will be processed at the lowest available level for a given processor.*/
    RoutingEntitiesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/routing/entities',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                organization: params.organization,
                owner: params.owner,
                processor: params.processor,
                sort: params.sort,
                status: params.status,
            },
        });
    };
    return RoutingEntitiesResource;
}($Resource));
export { RoutingEntitiesResource };
var ScreensResource = /** @class */ (function (_super) {
    __extends(ScreensResource, _super);
    function ScreensResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Provides a list of screens given a query 'q' and optional countries parameter to search on a specified list of countries.*/
    ScreensResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/screens/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return ScreensResource;
}($Resource));
export { ScreensResource };
var SearchProviderExportsResource = /** @class */ (function (_super) {
    __extends(SearchProviderExportsResource, _super);
    function SearchProviderExportsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchProviderExportsResource.prototype.post = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/search_provider_export",
            headers: params.headers,
            method: 'POST',
        });
    };
    SearchProviderExportsResource.prototype.postExperienceByExperienceKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/search_provider_export/experience/" + encodeURIComponent(params.experience_key),
            headers: params.headers,
            method: 'POST',
        });
    };
    return SearchProviderExportsResource;
}($Resource));
export { SearchProviderExportsResource };
var SecretsResource = /** @class */ (function (_super) {
    __extends(SecretsResource, _super);
    function SecretsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Update the status of this particular user*/
    SecretsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/secrets',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Create and publish a new secret*/
    SecretsResource.prototype.post = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/internal/secrets',
            headers: params.headers,
            method: 'POST',
        });
    };
    return SecretsResource;
}($Resource));
export { SecretsResource };
var SecretConfigsResource = /** @class */ (function (_super) {
    __extends(SecretConfigsResource, _super);
    function SecretConfigsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SecretConfigsResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/internal/secret/config',
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Update the config to set the preferred secret to the one specified*/
    SecretConfigsResource.prototype.putPreferredBySecretId = function (params) {
        return this.client.request({
            endpoint: "/internal/secret/config/preferred/" + encodeURIComponent(params.secret_id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return SecretConfigsResource;
}($Resource));
export { SecretConfigsResource };
var SessionCountriesResource = /** @class */ (function (_super) {
    __extends(SessionCountriesResource, _super);
    function SessionCountriesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SessionCountriesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/session/countries",
            headers: params.headers,
            method: 'GET',
        });
    };
    SessionCountriesResource.prototype.putByCountry = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/session/countries/" + encodeURIComponent(params.country),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return SessionCountriesResource;
}($Resource));
export { SessionCountriesResource };
var SessionOrderDataResource = /** @class */ (function (_super) {
    __extends(SessionOrderDataResource, _super);
    function SessionOrderDataResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SessionOrderDataResource.prototype.getBySessionId = function (params) {
        return this.client.request({
            endpoint: "/session/order/data/" + encodeURIComponent(params.session_id),
            headers: params.headers,
            method: 'GET',
        });
    };
    return SessionOrderDataResource;
}($Resource));
export { SessionOrderDataResource };
var SessionRolloutsResource = /** @class */ (function (_super) {
    __extends(SessionRolloutsResource, _super);
    function SessionRolloutsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SessionRolloutsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/session/rollout",
            headers: params.headers,
            method: 'GET',
        });
    };
    SessionRolloutsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/session/rollout",
            headers: params.headers,
            method: 'PUT',
        });
    };
    return SessionRolloutsResource;
}($Resource));
export { SessionRolloutsResource };
var ShopsResource = /** @class */ (function (_super) {
    __extends(ShopsResource, _super);
    function ShopsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShopsResource.prototype.getRedirectsAndOrderByApp = function (params) {
        return this.client.request({
            endpoint: "/shopify/shops/redirects/" + encodeURIComponent(params.app) + "/order",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                shop: params.shop,
            },
        });
    };
    ShopsResource.prototype.getByMyshopifyDomain = function (params) {
        return this.client.request({
            endpoint: "/shopify/shops/" + encodeURIComponent(params.myshopify_domain),
            headers: params.headers,
            method: 'GET',
        });
    };
    ShopsResource.prototype.putByMyshopifyDomain = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/shopify/shops/" + encodeURIComponent(params.myshopify_domain),
            headers: params.headers,
            method: 'PUT',
        });
    };
    ShopsResource.prototype.deleteByMyshopifyDomain = function (params) {
        return this.client.request({
            endpoint: "/shopify/shops/" + encodeURIComponent(params.myshopify_domain),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    ShopsResource.prototype.postInstallByMyshopifyDomain = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/shopify/shops/" + encodeURIComponent(params.myshopify_domain) + "/install",
            headers: params.headers,
            method: 'POST',
        });
    };
    ShopsResource.prototype.postSessionsByMyshopifyDomain = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/shopify/shops/" + encodeURIComponent(params.myshopify_domain) + "/sessions",
            headers: params.headers,
            method: 'POST',
        });
    };
    return ShopsResource;
}($Resource));
export { ShopsResource };
var ShopifyGiftCardBalancesResource = /** @class */ (function (_super) {
    __extends(ShopifyGiftCardBalancesResource, _super);
    function ShopifyGiftCardBalancesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Check the remaining balance on a Shopify gift card*/
    ShopifyGiftCardBalancesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/gift/cards/balances",
            headers: params.headers,
            method: 'POST',
        });
    };
    return ShopifyGiftCardBalancesResource;
}($Resource));
export { ShopifyGiftCardBalancesResource };
var ShopifyGiftCardRedemptionsResource = /** @class */ (function (_super) {
    __extends(ShopifyGiftCardRedemptionsResource, _super);
    function ShopifyGiftCardRedemptionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Redeems a Shopify gift card*/
    ShopifyGiftCardRedemptionsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/gift/cards/redemptions",
            headers: params.headers,
            method: 'POST',
        });
    };
    return ShopifyGiftCardRedemptionsResource;
}($Resource));
export { ShopifyGiftCardRedemptionsResource };
var ShopifyGiftCardReversalsResource = /** @class */ (function (_super) {
    __extends(ShopifyGiftCardReversalsResource, _super);
    function ShopifyGiftCardReversalsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Reverses a Shopify gift card redemption*/
    ShopifyGiftCardReversalsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/gift/cards/reversals",
            headers: params.headers,
            method: 'POST',
        });
    };
    return ShopifyGiftCardReversalsResource;
}($Resource));
export { ShopifyGiftCardReversalsResource };
var ShopifyGrantsChecksResource = /** @class */ (function (_super) {
    __extends(ShopifyGrantsChecksResource, _super);
    function ShopifyGrantsChecksResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShopifyGrantsChecksResource.prototype.getCheckHtml = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/shopify/grants/check.html',
            headers: params.headers,
            method: 'GET',
        });
    };
    return ShopifyGrantsChecksResource;
}($Resource));
export { ShopifyGrantsChecksResource };
var ShopifyOrderDetailsResource = /** @class */ (function (_super) {
    __extends(ShopifyOrderDetailsResource, _super);
    function ShopifyOrderDetailsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Check inventory for a provided set of items, ensuring expected quantities are in stock.*/
    ShopifyOrderDetailsResource.prototype.postChecksAndInventory = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/orders/checks/inventory",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
            },
        });
    };
    /*Endpoint to inject a submitted order directly to shopify, bypassing event processing*/
    ShopifyOrderDetailsResource.prototype.postEnsure = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/orders/ensure",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
            },
        });
    };
    /*Check inventory for order items, ensuring expected quantities are in stock.*/
    ShopifyOrderDetailsResource.prototype.getChecksAndInventoryByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/orders/" + encodeURIComponent(params.number) + "/checks/inventory",
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
            },
        });
    };
    /*Based on the code, determine if a gift card or promotion is applied to the order.  Attempt will be made to first validate and apply code as a gift card.  If not applicable, attempt to validate and apply the code as a promotion.  This endpoint achieves the same behavior as calling '/payments/gift-card' followed by /promotion.*/
    ShopifyOrderDetailsResource.prototype.postCodesByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/orders/" + encodeURIComponent(params.number) + "/codes",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
                expand: params.expand,
            },
        });
    };
    ShopifyOrderDetailsResource.prototype.getContentsByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/orders/" + encodeURIComponent(params.number) + "/contents",
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Apply gift card payment on the order. A gift card can be applied at most once per order.*/
    ShopifyOrderDetailsResource.prototype.postPaymentsAndGiftCardByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/orders/" + encodeURIComponent(params.number) + "/payments/gift-card",
            headers: params.headers,
            method: 'POST',
            query: {
                expand: params.expand,
            },
        });
    };
    /*Set the promotion code on the cart - shopify only supports up to 1 promotion code. If the cart already had another promotion code, replaces that code with the provided one.*/
    ShopifyOrderDetailsResource.prototype.putPromotionByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/orders/" + encodeURIComponent(params.number) + "/promotion",
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
                expand: params.expand,
            },
        });
    };
    /*If the cart has a promotion code applied to it, removes that promotion code*/
    ShopifyOrderDetailsResource.prototype.deletePromotionByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/orders/" + encodeURIComponent(params.number) + "/promotion",
            headers: params.headers,
            method: 'DELETE',
            query: {
                context: params.context,
                expand: params.expand,
            },
        });
    };
    /*If the cart has a promotion code applied to it, removes that promotion code. Similar to DELETE /:number/promotion but with a different path.*/
    ShopifyOrderDetailsResource.prototype.deletePromotionAndDeleteByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/orders/" + encodeURIComponent(params.number) + "/promotion/delete",
            headers: params.headers,
            method: 'DELETE',
            query: {
                context: params.context,
                expand: params.expand,
            },
        });
    };
    /*Clear and apply automatic discounts only on the order. No discount codes are needed.*/
    ShopifyOrderDetailsResource.prototype.putPromotionsAndAutoAndApplyByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/orders/" + encodeURIComponent(params.number) + "/promotions/auto/apply",
            headers: params.headers,
            method: 'PUT',
            query: {
                expand: params.expand,
            },
        });
    };
    /*Returns order authorization details.*/
    ShopifyOrderDetailsResource.prototype.getSubmissionsByNumberAndAuthorizationKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/orders/" + encodeURIComponent(params.number) + "/submissions/" + encodeURIComponent(params.authorization_key),
            headers: params.headers,
            method: 'GET',
            query: {
                expand: params.expand,
            },
        });
    };
    return ShopifyOrderDetailsResource;
}($Resource));
export { ShopifyOrderDetailsResource };
var ShopifyOrganizationSettingsResource = /** @class */ (function (_super) {
    __extends(ShopifyOrganizationSettingsResource, _super);
    function ShopifyOrganizationSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShopifyOrganizationSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/organization/settings",
            headers: params.headers,
            method: 'GET',
        });
    };
    ShopifyOrganizationSettingsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/organization/settings",
            headers: params.headers,
            method: 'POST',
        });
    };
    ShopifyOrganizationSettingsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/organization/settings",
            headers: params.headers,
            method: 'PUT',
        });
    };
    ShopifyOrganizationSettingsResource.prototype.delete = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/organization/settings",
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ShopifyOrganizationSettingsResource;
}($Resource));
export { ShopifyOrganizationSettingsResource };
var ShopifyPromotionsResource = /** @class */ (function (_super) {
    __extends(ShopifyPromotionsResource, _super);
    function ShopifyPromotionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShopifyPromotionsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/promotions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                status: params.status,
            },
        });
    };
    ShopifyPromotionsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/promotions",
            headers: params.headers,
            method: 'POST',
        });
    };
    ShopifyPromotionsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/promotions/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    ShopifyPromotionsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/promotions/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return ShopifyPromotionsResource;
}($Resource));
export { ShopifyPromotionsResource };
var ShopifyWebhookEventsResource = /** @class */ (function (_super) {
    __extends(ShopifyWebhookEventsResource, _super);
    function ShopifyWebhookEventsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShopifyWebhookEventsResource.prototype.postShopsByShopifyShopIdAndTopicAndAction = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/shopify/webhook/events/shops/" + encodeURIComponent(params.shopify_shop_id) + "/" + encodeURIComponent(params.topic) + "/" + encodeURIComponent(params.action),
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
            },
        });
    };
    ShopifyWebhookEventsResource.prototype.postByTopicAndAction = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/shopify/webhook/events/" + encodeURIComponent(params.topic) + "/" + encodeURIComponent(params.action),
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
            },
        });
    };
    return ShopifyWebhookEventsResource;
}($Resource));
export { ShopifyWebhookEventsResource };
var SpotRatesResource = /** @class */ (function (_super) {
    __extends(SpotRatesResource, _super);
    function SpotRatesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search spot rates. Always paginated.*/
    SpotRatesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/internal/currency/spot-rates',
            headers: params.headers,
            method: 'GET',
            query: {
                base: params.base,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                target: params.target,
            },
        });
    };
    /*Provides visibility into recent changes of each object, including deletion.*/
    SpotRatesResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: '/internal/currency/spot-rates/versions',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    return SpotRatesResource;
}($Resource));
export { SpotRatesResource };
var StoreConnectionsResource = /** @class */ (function (_super) {
    __extends(StoreConnectionsResource, _super);
    function StoreConnectionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StoreConnectionsResource.prototype.getByDomain = function (params) {
        return this.client.request({
            endpoint: "/magento/stores/" + encodeURIComponent(params.domain),
            headers: params.headers,
            method: 'GET',
        });
    };
    StoreConnectionsResource.prototype.putByDomain = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/magento/stores/" + encodeURIComponent(params.domain),
            headers: params.headers,
            method: 'PUT',
        });
    };
    StoreConnectionsResource.prototype.deleteByDomain = function (params) {
        return this.client.request({
            endpoint: "/magento/stores/" + encodeURIComponent(params.domain),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    StoreConnectionsResource.prototype.postInstallByDomain = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/magento/stores/" + encodeURIComponent(params.domain) + "/install",
            headers: params.headers,
            method: 'POST',
        });
    };
    return StoreConnectionsResource;
}($Resource));
export { StoreConnectionsResource };
var TariffEligibilitiesResource = /** @class */ (function (_super) {
    __extends(TariffEligibilitiesResource, _super);
    function TariffEligibilitiesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TariffEligibilitiesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/harmonization/tariff/eligibilities",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                type: params.type,
            },
        });
    };
    TariffEligibilitiesResource.prototype.getByType = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/harmonization/tariff/eligibilities/" + encodeURIComponent(params.type),
            headers: params.headers,
            method: 'GET',
        });
    };
    TariffEligibilitiesResource.prototype.putByType = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/harmonization/tariff/eligibilities/" + encodeURIComponent(params.type),
            headers: params.headers,
            method: 'PUT',
        });
    };
    TariffEligibilitiesResource.prototype.deleteByType = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/harmonization/tariff/eligibilities/" + encodeURIComponent(params.type),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return TariffEligibilitiesResource;
}($Resource));
export { TariffEligibilitiesResource };
var TaxCalculationFormsResource = /** @class */ (function (_super) {
    __extends(TaxCalculationFormsResource, _super);
    function TaxCalculationFormsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*In some cases, a third party service is used to authorize, record or adjust Flow's estimated tax calculations to ensure compliance. Calling this method when no third party clearance is necessary, or no third party is set up, will result in a 422. A 500x will be issued if a third party is required but is offline, slow or has errors.*/
    TaxCalculationFormsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/tax/calculation",
            headers: params.headers,
            method: 'POST',
        });
    };
    return TaxCalculationFormsResource;
}($Resource));
export { TaxCalculationFormsResource };
var TribesResource = /** @class */ (function (_super) {
    __extends(TribesResource, _super);
    function TribesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*List all tribes. There is no pagination as number of tribes is small.*/
    TribesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/tribes",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
            },
        });
    };
    TribesResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/tribes/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    return TribesResource;
}($Resource));
export { TribesResource };
var UnclassifiedProductsPurgeRequestsResource = /** @class */ (function (_super) {
    __extends(UnclassifiedProductsPurgeRequestsResource, _super);
    function UnclassifiedProductsPurgeRequestsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Deletes products from the `unclassified_products` table for all the organizations listed into: [excluded-orgs.json](https://github.com/flowcommerce/harmonization/blob/main/core/conf/excluded-orgs.json)*/
    UnclassifiedProductsPurgeRequestsResource.prototype.post = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/classification/unclassified/products/purge/request',
            headers: params.headers,
            method: 'POST',
        });
    };
    return UnclassifiedProductsPurgeRequestsResource;
}($Resource));
export { UnclassifiedProductsPurgeRequestsResource };
var UnclassifiedProductsSummariesResource = /** @class */ (function (_super) {
    __extends(UnclassifiedProductsSummariesResource, _super);
    function UnclassifiedProductsSummariesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UnclassifiedProductsSummariesResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/classification/unclassified/products/summary',
            headers: params.headers,
            method: 'GET',
        });
    };
    return UnclassifiedProductsSummariesResource;
}($Resource));
export { UnclassifiedProductsSummariesResource };
var UserOneTimeTokensResource = /** @class */ (function (_super) {
    __extends(UserOneTimeTokensResource, _super);
    function UserOneTimeTokensResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Create a one time token to represent the authenticated user. Token is valid for 30 seconds.*/
    UserOneTimeTokensResource.prototype.post = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/users/tokens',
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Retrieves a user if the token is valid. Once called, the token is immediately invalidated and cannot be used again.*/
    UserOneTimeTokensResource.prototype.postRedeem = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/users/tokens/redeem',
            headers: params.headers,
            method: 'POST',
        });
    };
    return UserOneTimeTokensResource;
}($Resource));
export { UserOneTimeTokensResource };
var V1CheckoutsResource = /** @class */ (function (_super) {
    __extends(V1CheckoutsResource, _super);
    function V1CheckoutsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    V1CheckoutsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/checkouts',
            headers: params.headers,
            method: 'POST',
        });
    };
    V1CheckoutsResource.prototype.getV1ByV2CheckoutId = function (params) {
        return this.client.request({
            endpoint: "/checkouts/v1/" + encodeURIComponent(params.v2_checkout_id),
            headers: params.headers,
            method: 'GET',
        });
    };
    V1CheckoutsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/checkouts/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
            query: {
                feature_key: params.feature_key,
            },
        });
    };
    V1CheckoutsResource.prototype.putSubmissionsById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/checkouts/" + encodeURIComponent(params.id) + "/submissions",
            headers: params.headers,
            method: 'PUT',
        });
    };
    return V1CheckoutsResource;
}($Resource));
export { V1CheckoutsResource };
var V2CheckoutsResource = /** @class */ (function (_super) {
    __extends(V2CheckoutsResource, _super);
    function V2CheckoutsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Creates a checkout based on the session id*/
    V2CheckoutsResource.prototype.postSessionBySessionId = function (params) {
        return this.client.request({
            endpoint: "/v2/checkouts/session/" + encodeURIComponent(params.session_id),
            headers: params.headers,
            method: 'POST',
        });
    };
    V2CheckoutsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/v2/checkouts/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    V2CheckoutsResource.prototype.getOrderAndViewsById = function (params) {
        return this.client.request({
            endpoint: "/v2/checkouts/" + encodeURIComponent(params.id) + "/order/views",
            headers: params.headers,
            method: 'GET',
        });
    };
    V2CheckoutsResource.prototype.getResponseById = function (params) {
        return this.client.request({
            endpoint: "/v2/checkouts/" + encodeURIComponent(params.id) + "/response",
            headers: params.headers,
            method: 'GET',
        });
    };
    return V2CheckoutsResource;
}($Resource));
export { V2CheckoutsResource };
var ViesResultsResource = /** @class */ (function (_super) {
    __extends(ViesResultsResource, _super);
    function ViesResultsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ViesResultsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/tax/registration',
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                name: params.name,
                number: params.number,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    ViesResultsResource.prototype.getByNumber = function (params) {
        return this.client.request({
            endpoint: "/tax/registration/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'GET',
            query: {
                name: params.name,
            },
        });
    };
    return ViesResultsResource;
}($Resource));
export { ViesResultsResource };
export function createClient(options) {
    return {
        accounts: new AccountsResource(options),
        addressConfigurationSettings: new AddressConfigurationSettingsResource(options),
        alertFailureSummaries: new AlertFailureSummariesResource(options),
        alertRequeueSummaries: new AlertRequeueSummariesResource(options),
        authorizedChargeStatuses: new AuthorizedChargeStatusesResource(options),
        backfills: new BackfillsResource(options),
        bankPayments: new BankPaymentsResource(options),
        billingStatements: new BillingStatementsResource(options),
        billingStatementPendingReviews: new BillingStatementPendingReviewsResource(options),
        billingStatementReviews: new BillingStatementReviewsResource(options),
        brickWebhookEvents: new BrickWebhookEventsResource(options),
        browserBundles: new BrowserBundlesResource(options),
        carrierAccounts: new CarrierAccountsResource(options),
        centerQueryBuilders: new CenterQueryBuildersResource(options),
        chargebacks: new ChargebacksResource(options),
        checkoutBundles: new CheckoutBundlesResource(options),
        checkoutConfigurations: new CheckoutConfigurationsResource(options),
        checkoutContentSummaries: new CheckoutContentSummariesResource(options),
        checkoutFinalizeOrderForms: new CheckoutFinalizeOrderFormsResource(options),
        checkoutHttpSequencedRequests: new CheckoutHttpSequencedRequestsResource(options),
        checkoutHttpSequencedResponses: new CheckoutHttpSequencedResponsesResource(options),
        checkoutSubmitOrderBundles: new CheckoutSubmitOrderBundlesResource(options),
        ciphers: new CiphersResource(options),
        classificationDetails: new ClassificationDetailsResource(options),
        classificationProductSummaryPages: new ClassificationProductSummaryPagesResource(options),
        classificationRequeueRequests: new ClassificationRequeueRequestsResource(options),
        classificationStatistics: new ClassificationStatisticsResource(options),
        classificationTaxonomy: new ClassificationTaxonomyResource(options),
        compliances: new CompliancesResource(options),
        consumerOptinActivities: new ConsumerOptinActivitiesResource(options),
        contentSchemas: new ContentSchemasResource(options),
        customerSecrets: new CustomerSecretsResource(options),
        customsDetails: new CustomsDetailsResource(options),
        deliveredDutyOptions: new DeliveredDutyOptionsResource(options),
        deliveredDutyPreferences: new DeliveredDutyPreferencesResource(options),
        discountCodes: new DiscountCodesResource(options),
        dutyInternalRates: new DutyInternalRatesResource(options),
        experiments: new ExperimentsResource(options),
        experimentFormDefaults: new ExperimentFormDefaultsResource(options),
        experimentResultsWithTimestamps: new ExperimentResultsWithTimestampsResource(options),
        features: new FeaturesResource(options),
        featureValues: new FeatureValuesResource(options),
        flowCurrencySettings: new FlowCurrencySettingsResource(options),
        flowLabProjects: new FlowLabProjectsResource(options),
        flowLabelSettings: new FlowLabelSettingsResource(options),
        fraudReviews: new FraudReviewsResource(options),
        fraudReviewDecisions: new FraudReviewDecisionsResource(options),
        ftpSettings: new FtpSettingsResource(options),
        giftCardPrograms: new GiftCardProgramsResource(options),
        globalSearchResults: new GlobalSearchResultsResource(options),
        googleShoppingSettings: new GoogleShoppingSettingsResource(options),
        internalHarmonizationStatistics: new InternalHarmonizationStatisticsResource(options),
        inventoryOrganizationSettings: new InventoryOrganizationSettingsResource(options),
        notificationRequests: new NotificationRequestsResource(options),
        invoiceWebhookResponses: new InvoiceWebhookResponsesResource(options),
        checkoutReferences: new CheckoutReferencesResource(options),
        users: new UsersResource(options),
        cryptoEvents: new CryptoEventsResource(options),
        rates: new RatesResource(options),
        experiences: new ExperiencesResource(options),
        orders: new OrdersResource(options),
        webhookEvents: new WebhookEventsResource(options),
        receiptNotifications: new ReceiptNotificationsResource(options),
        shipmentNotifications: new ShipmentNotificationsResource(options),
        reservations: new ReservationsResource(options),
        orderManagementEvents: new OrderManagementEventsResource(options),
        organizationShortIds: new OrganizationShortIdsResource(options),
        authorizations: new AuthorizationsResource(options),
        permissionAudits: new PermissionAuditsResource(options),
        simplePermissionChecks: new SimplePermissionChecksResource(options),
        queryBuilders: new QueryBuildersResource(options),
        countries: new CountriesResource(options),
        contexts: new ContextsResource(options),
        organizationSessions: new OrganizationSessionsResource(options),
        shopifyCarts: new ShopifyCartsResource(options),
        shopifyCartConversions: new ShopifyCartConversionsResource(options),
        shopifyLocalizedVariants: new ShopifyLocalizedVariantsResource(options),
        stripeEvents: new StripeEventsResource(options),
        svbNotifications: new SvbNotificationsResource(options),
        itemClassifications: new ItemClassificationsResource(options),
        itemClassificationSummaries: new ItemClassificationSummariesResource(options),
        itemHarmonizations: new ItemHarmonizationsResource(options),
        itemRestrictions: new ItemRestrictionsResource(options),
        itemSalesMargins: new ItemSalesMarginsResource(options),
        keys: new KeysResource(options),
        labProjectSettings: new LabProjectSettingsResource(options),
        labelGenerationSettings: new LabelGenerationSettingsResource(options),
        labelTaxonomy: new LabelTaxonomyResource(options),
        liabilityRemittancePlans: new LiabilityRemittancePlansResource(options),
        localizableContents: new LocalizableContentsResource(options),
        localizations: new LocalizationsResource(options),
        localizedContents: new LocalizedContentsResource(options),
        localizedItemsExportSettings: new LocalizedItemsExportSettingsResource(options),
        loyaltyPrograms: new LoyaltyProgramsResource(options),
        marketingGatewayChannels: new MarketingGatewayChannelsResource(options),
        marketingGatewayChannelSourceSummaries: new MarketingGatewayChannelSourceSummariesResource(options),
        marketingGatewayFacebookBusinesses: new MarketingGatewayFacebookBusinessesResource(options),
        marketingGatewayFacebookConnections: new MarketingGatewayFacebookConnectionsResource(options),
        marketingGatewayFacebookConnectionAccessTokenSummaries: new MarketingGatewayFacebookConnectionAccessTokenSummariesResource(options),
        marketingGatewayFacebookConnectionDeauths: new MarketingGatewayFacebookConnectionDeauthsResource(options),
        marketingGatewayFeeds: new MarketingGatewayFeedsResource(options),
        marketingGatewayFeedForms: new MarketingGatewayFeedFormsResource(options),
        marketingGatewayFeedSources: new MarketingGatewayFeedSourcesResource(options),
        marketingGatewayGoogleConnections: new MarketingGatewayGoogleConnectionsResource(options),
        marketingGatewayLocalizedItems: new MarketingGatewayLocalizedItemsResource(options),
        merchantOfRecordEntitySettings: new MerchantOfRecordEntitySettingsResource(options),
        notifications: new NotificationsResource(options),
        optinAttributes: new OptinAttributesResource(options),
        optinPrompts: new OptinPromptsResource(options),
        optinPromptCopies: new OptinPromptCopiesResource(options),
        orderActionabilities: new OrderActionabilitiesResource(options),
        orderDetails: new OrderDetailsResource(options),
        orderPaymentAuthorizations: new OrderPaymentAuthorizationsResource(options),
        orderRevenueRegionCharts: new OrderRevenueRegionChartsResource(options),
        orderRevenueTimelineCharts: new OrderRevenueTimelineChartsResource(options),
        organizationMembershipCopies: new OrganizationMembershipCopiesResource(options),
        organizationSettings: new OrganizationSettingsResource(options),
        partners: new PartnersResource(options),
        partnerAuthorizations: new PartnerAuthorizationsResource(options),
        partnerMemberships: new PartnerMembershipsResource(options),
        partnerOrganizationAuthorizations: new PartnerOrganizationAuthorizationsResource(options),
        passphrases: new PassphrasesResource(options),
        paymentOrganizationSettings: new PaymentOrganizationSettingsResource(options),
        paymentRedirects: new PaymentRedirectsResource(options),
        pendingBankPayments: new PendingBankPaymentsResource(options),
        platformFeeChanges: new PlatformFeeChangesResource(options),
        processorAccounts: new ProcessorAccountsResource(options),
        processorMerchants: new ProcessorMerchantsResource(options),
        productClassifications: new ProductClassificationsResource(options),
        ratecardStandardConfigurations: new RatecardStandardConfigurationsResource(options),
        ratesNamesSummaries: new RatesNamesSummariesResource(options),
        reboundConfigurations: new ReboundConfigurationsResource(options),
        routingEntities: new RoutingEntitiesResource(options),
        screens: new ScreensResource(options),
        searchProviderExports: new SearchProviderExportsResource(options),
        secrets: new SecretsResource(options),
        secretConfigs: new SecretConfigsResource(options),
        sessionCountries: new SessionCountriesResource(options),
        sessionOrderData: new SessionOrderDataResource(options),
        sessionRollouts: new SessionRolloutsResource(options),
        shops: new ShopsResource(options),
        shopifyGiftCardBalances: new ShopifyGiftCardBalancesResource(options),
        shopifyGiftCardRedemptions: new ShopifyGiftCardRedemptionsResource(options),
        shopifyGiftCardReversals: new ShopifyGiftCardReversalsResource(options),
        shopifyGrantsChecks: new ShopifyGrantsChecksResource(options),
        shopifyOrderDetails: new ShopifyOrderDetailsResource(options),
        shopifyOrganizationSettings: new ShopifyOrganizationSettingsResource(options),
        shopifyPromotions: new ShopifyPromotionsResource(options),
        shopifyWebhookEvents: new ShopifyWebhookEventsResource(options),
        spotRates: new SpotRatesResource(options),
        storeConnections: new StoreConnectionsResource(options),
        tariffEligibilities: new TariffEligibilitiesResource(options),
        taxCalculationForms: new TaxCalculationFormsResource(options),
        tribes: new TribesResource(options),
        unclassifiedProductsPurgeRequests: new UnclassifiedProductsPurgeRequestsResource(options),
        unclassifiedProductsSummaries: new UnclassifiedProductsSummariesResource(options),
        userOneTimeTokens: new UserOneTimeTokensResource(options),
        v1Checkouts: new V1CheckoutsResource(options),
        v2Checkouts: new V2CheckoutsResource(options),
        viesResults: new ViesResultsResource(options),
    };
}



//////////////////
// WEBPACK FOOTER
// ./~/@flowio/api-internal-sdk/dist/esm/api-internal.js
// module id = 459
// module chunks = 0 1